"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t;
    return { next: verb(0), "throw": verb(1), "return": verb(2) };
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var URLSearchParams = require("url-search-params");
var models_1 = require("../../models");
var mapping_1 = require("../../mapping");
var JobRequisitionLocationDataProvider_1 = require("../../shared/JobRequisitionLocationDataProvider");
var SignStatusSetter_1 = require("../../shared/SignStatusSetter");
var LocalizedLanguageSetter_1 = require("../../shared/LocalizedLanguageSetter");
var JobRequisitionApplyStatusGetter_1 = require("../../shared/JobRequisitionApplyStatusGetter");
var player_scroll_to_1 = require("player-scroll-to");
var mapping = require("../../mapping");
require("../../shared/MobileTypography.css");
require("../../shared/csod-bootstrap.css");
var JobRequisitionShareLinkGetter_1 = require("../../shared/JobRequisitionShareLinkGetter");
var ApplyUrl_1 = require("../../shared/ApplyUrl");
var CareerSiteUrlProvider_1 = require("../../shared/CareerSiteUrlProvider");
var history_1 = require("../../shared/history");
var qs = require("qs");
var SearchFilterMapper_1 = require("../../api/SearchFilterMapper");
var ReferralTokenChecker_1 = require("../../shared/ReferralTokenChecker");
var RandomGenerator_1 = require("../../shared/RandomGenerator");
var JobRequisitionPostedDateGetter_1 = require("../../shared/JobRequisitionPostedDateGetter");
var jobDetailProvider = new JobRequisitionLocationDataProvider_1.JobRequisitionLocationDataProvider();
var signStatusSetter = new SignStatusSetter_1.SignStatusSetter();
var languageSetter = new LocalizedLanguageSetter_1.LocalizedLanguageSetter();
var shareLinkGetter = new JobRequisitionShareLinkGetter_1.JobRequisitionShareLinkGetter();
var applyStatusGetter = new JobRequisitionApplyStatusGetter_1.JobRequisitionApplyStatusGetter();
var careerSiteUrlProvider = new CareerSiteUrlProvider_1.CareerSiteUrlProvider(csod.context.applicationBase, csod.context.corp, csodPlayerRouteInfo.cid, csod.context.cultureName);
var routePrefix = careerSiteUrlProvider.getRoutePrefix();
var shouldUseHashRouter = window.location.hash.length > 0;
var randomGenerator = new RandomGenerator_1.RandomGenerator();
var jobRequisitionPostedDateGetter = new JobRequisitionPostedDateGetter_1.JobRequisitionPostedDateGetter();
var DROPDOWN_SINGLE_SELECT = "select";
var DROPDOWN_MULTI_SELECT = "checkbox-search";
var ANYTIME = 'Anytime';
var searchFilterMapper = new SearchFilterMapper_1.SearchFilterMapper();
csod.viewModel = {
    CustomFields: new Map(),
    CustomFieldsObjects: [],
    customFieldIds: [],
    hasCFMainSearch: false,
    cfMainIsMultiselect: false,
    cfMainSearchDropdownTitle: '',
    cfMainSearchDropdownId: -1,
    cfFilterToResetOptions: [],
    cfMainSearchDropDownOptions: [],
    cfLastSearchedFilterSnapshot: null,
    cfDefaultDropdownText: "",
    cfDefaultRadioButtonText: "",
    selectedFilterFlaglist: [],
    routerType: shouldUseHashRouter ? "Hash" : "Browser",
    homePath: shouldUseHashRouter ? "/" : "" + routePrefix,
    jobDetailsPath: shouldUseHashRouter ? '/requisition/:id' : routePrefix + "/requisition/:id",
    searchUrl: careerSiteUrlProvider.getSearchURL(),
    nonCustomFieldParams: '',
    isLoading: false,
    IS_FIRST_LOAD: true,
    headerData: {
        isAdvanced: false,
        html: "",
        color: "",
        imagePath: "",
        imageAlt: ""
    },
    footerData: {
        isAdvanced: false,
        html: "",
        color: "",
        imagePath: "",
        imageAlt: ""
    },
    siteSettings: {
        allowedLanguages: [],
        currentLanguage: "0",
        showToolbar: true,
        currentLanguageDetail: {
            cultureId: "1",
            cultureName: "en-US"
        },
        mapsApiKey: "",
        mapsIsPremium: false,
        allowSEO: false,
        jobPostingSEOLogoPath: ""
    },
    mapsApiLoaded: false,
    mapsApiService: "",
    isSignedIn: false,
    signUrl: "",
    signText: "",
    signInText: "",
    signOutText: "",
    profileUrl: "",
    profileText: "",
    myProfileText: "",
    createProfileText: "",
    searchBanner: {
        bannerImagePath: "",
        bannerHtml: "",
        currentKeywordQuery: "",
        keywordSearchPlaceholder: "",
        keywordSearchAriaLabel: "",
        keywordSearchPredictions: [],
        keywordSearchNoResults: "",
        currentLocationQuery: "",
        locationSearchPlaceholder: "",
        locationSearchPredictions: [],
        locationSearchNoResults: "",
        buttonText: "",
        placeId: ""
    },
    searchBannerContentHeight: 0,
    searchBannerContentRef: null,
    navigation: {
        iconColor: "Muted",
        textColor: "Primary",
        backText: "",
        prevText: "",
        nextText: ""
    },
    companyInformationHtml: "<span>This is Company Information</span>",
    searchResults: [],
    hasSearched: false,
    isKeywordSearch: false,
    scrollToResultsFromDetails: false,
    totalSearchResults: 0,
    currentResultPage: 1,
    totalResultPages: 1,
    resultPageSize: 25,
    sortOptions: [
        {
            "label": "Distance",
            "value": "distance"
        },
        {
            "label": "Relevance",
            "value": "relevance"
        },
        {
            "label": "Date Posted",
            "value": "datePosted"
        }
    ],
    jobSearchMap: {
        apiKey: csodGoogleMapsClientApi.key,
        defaultZoom: 12,
        centerLat: 34.028121,
        centerLng: -118.472665,
        iconPath: csod.context.basePath + "assets/mapMarkerIcon.png",
        selectedMarkerIconPath: csod.context.basePath + "assets/mapSelectedMarkerIcon.png",
        infoWindowHeaderColor: 'Primary',
        markers: [
            {
                id: 1,
                lat: 34.028121,
                lng: -118.472665,
                headerText: 'Regional Sales Manager',
                subheaderText: 'Santa Monica, CA',
                description: 'May 5, 2017'
            },
            {
                id: 12345,
                lat: 34.028335,
                lng: -118.467679,
                description: 'blah'
            }
        ],
        loadingText: '',
        selectedMarkerId: 1
    },
    jobDetails: {
        jobAd: "",
        title: "",
        externalDescription: "",
        ref: "",
        primaryLocation: {
            title: "",
            locationDisplayTitle: "",
            geocode: {
                latitude: "",
                longitude: ""
            },
            city: "",
            state: "",
            country: "",
            postalCode: "",
            line1: ""
        },
        additionalLocations: new Array(),
        applyNowStatusText: "",
        applyNowStatusId: -1,
        canUserApply: false,
        saveJobText: "",
        isSaveJobDisabled: true,
        isJobAvailableToApply: true,
        startDate: "",
        endDate: "",
        postedDateLabel: "",
    },
    jobDetailsBannerPath: "",
    jobDetailsBannerContentHeight: 0,
    jobDetailsBannerContentRef: null,
    shareBtnText: "",
    shareOptions: [
        {
            label: "",
            value: "email",
            title: "email",
            closeOnClick: true,
            isDisabled: false
        },
        {
            label: "",
            value: "linkedIn",
            title: "linkedIn",
            closeOnClick: true,
            isDisabled: false
        },
        {
            label: "",
            value: "Facebook",
            title: "",
            closeOnClick: true,
            isDisabled: false
        }
    ],
    locationDisplay: "",
    allLocations: new Array(),
    hasAdditionalLocations: false,
    resetText: "",
    applyText: "",
    cancelText: "",
    openFilterFlyoutText: "",
    filtersText: "",
    filters: [],
    selectedFilters: [],
    tempFilters: [],
    tempSelectedFilters: [],
    lastSelectedFilter: null,
    filterFlyoutIsOpen: false,
    isDesktop: true,
    searchResultsNumberOfPagesShownInPagination: 5,
    isJobAlertsEnabled: false,
    hasJobSearchOrFilterApplied: false,
    jobAlert: {
        showCreateModal: false,
        modalTitle: "Create an alert",
        modalInstruction: "And get notified by email as soon as a job matches with your criteria.",
        titleCaption: "Name",
        title: "",
        titleErrorMsg: "",
        titleErrorMsgTranslation: "Name is required",
        frequencyCaption: "Cadence",
        frequency: [
            {
                label: "Daily",
                value: "1"
            },
            {
                label: "Weekly",
                value: "2"
            }
        ],
        selectedFrequency: "1",
        createBtnText: "Create",
        cancelBtnText: "Cancel",
        yourCriteriaCaption: "Your criteria",
        criteria: [],
        showEmailValidationErrorModal: false,
        emailValidationErrorModalTitle: "Cannot create an alert",
        emailValidationErrorModalText: "You must update your profile and provide an e-mail address before setting up an alert.",
        closeBtnText: "Close",
        showFilterValidationErrorModal: false,
        filterValidationErrorModalTitle: "Create an alert",
        filterValidationErrorModalText: "You'll need to apply at least one search or filter before creating a job alert.",
    },
    userEmail: "",
    organizationName: "",
    languageSetterLabel: "",
    isCareerSiteDisplayPostingEndDateEnabled: "",
    isPostingDateInJobDetailsPageEnabled: "",
    isExternalCareerSiteDisplayKilometerFilterEnabled: "",
    isEnableCountryStateCityFilterMFCEnabled: "",
    isEnableAllValuesForCustomFieldInMFCEnabled: false,
    bootstrapHomeServices: function () {
        clearJobDetails();
        var searchPageUrl = "~/ux/ats/careersite/" + csodPlayerRouteInfo.cid + "/home?c=" + csod.context.corp;
        var cultureId = getCurrentCultureId();
        getEnableAllValuesForCustomFieldInMFC();
        getEnableCountryStateCityFilterMFC().then(function () {
            getOuLocations().then(function () {
                loadSiteSettings(cultureId, searchPageUrl, function () { });
            });
        });
        getCareerSiteDisplayPostingEndDate();
        getPostingDateInJobDetailsPage();
        getExternalCareerSiteDisplayKilometerFilter();
        csod.pageDefinition.events.onDropdownSelect = function (selectedCultureId) {
            mapping_1.bootstrap(csodPlayerRouteInfo.cid, selectedCultureId)
                .then(resetLastSelectedFilters)
                .then(populateSiteSettings)
                .then(setLanguageAsQueryStringParameter)
                .then(transformCustomFieldFilters)
                .then(search);
        };
    },
    bootstrapDetailsServices: function () {
        clearJobDetails();
        getExternalCareerSiteDisplayKilometerFilter();
        getCareerSiteDisplayPostingEndDate().then(function () {
            getPostingDateInJobDetailsPage().then(function () {
                getEnableCountryStateCityFilterMFC().then(function () {
                    getOuLocations().then(function () {
                        var l = csod.viewModel.routerType === 'Hash' ? window.location.href.split("/") : window.location.pathname.split("/");
                        for (var i = 0; i < l.length; i++) {
                            if (l[i] == "careersite")
                                csod.viewModel.careerSiteId = l[i + 1];
                            if (l[i] == "requisition") {
                                if (l[i + 1].indexOf('?') > -1)
                                    csod.viewModel.reqId = l[i + 1].split("?")[0];
                                else if (l[i + 1].indexOf('&') > -1)
                                    csod.viewModel.reqId = l[i + 1].split("&")[0];
                                else
                                    csod.viewModel.reqId = l[i + 1];
                            }
                        }
                        var cultureId = getCurrentCultureId();
                        var jobDetailsUrl = careerSiteUrlProvider.getMobileFriendlyJobDetailUrl(csod.viewModel.reqId, window.location.search);
                        csod.viewModel.scrollToResultsFromDetails = true;
                        ReferralTokenChecker_1.ReferralTokenChecker.checkForReferralToken();
                        loadSiteSettings(cultureId, jobDetailsUrl, populateReqDetails).then(function () {
                            var requisitionDetail = csod.viewModel.searchResults.find(function (r) { return r.id == csod.viewModel.reqId; });
                            csod.viewModel.jobDetails.postedDateLabel =
                                (requisitionDetail ? jobRequisitionPostedDateGetter.getJobRequisitionPostedDateLabelForJobDetailsPage(requisitionDetail.startDate, requisitionDetail.endDate, csod.viewModel.isPostingDateInJobDetailsPageEnabled.toLocaleLowerCase() === "true", csod.viewModel.isCareerSiteDisplayPostingEndDateEnabled.toLocaleLowerCase() === "true") : "");
                            csod.engine.commit();
                        });
                        csod.pageDefinition.events.onDropdownSelect = function (selectedCultureId) {
                            mapping.bootstrap(csodPlayerRouteInfo.cid, selectedCultureId)
                                .then(populateSiteSettings)
                                .then(transformCustomFieldFilters)
                                .then(function () {
                                populateReqDetails();
                                setLanguageAttribute(csod.viewModel.siteSettings.currentLanguageDetail.cultureName);
                                setLanguageAsQueryStringParameter();
                                search();
                            })
                                .then(function () {
                                var requisitionDetail = csod.viewModel.searchResults.find(function (r) { return r.id == csod.viewModel.reqId; });
                                csod.viewModel.jobDetails.postedDateLabel =
                                    (requisitionDetail ? jobRequisitionPostedDateGetter.getJobRequisitionPostedDateLabelForJobDetailsPage(requisitionDetail.startDate, requisitionDetail.endDate, csod.viewModel.isPostingDateInJobDetailsPageEnabled.toLocaleLowerCase() === "true", csod.viewModel.isCareerSiteDisplayPostingEndDateEnabled.toLocaleLowerCase() === "true") : "");
                                csod.engine.commit();
                            });
                        };
                    });
                });
            });
        });
    }
};
csod.pageDefinition = {
    mocks: {
        enabled: false,
        services: [
            'filters'
        ],
        type: 'js',
        timeOut: 10
    },
    locales: ["CareerSite"],
    initialize: function () {
        setLanguageAttribute(csod.context.cultureName);
        if (csod.context.user > 0) {
            setUserEmail();
        }
        return new Promise(function (resolve, reject) {
            csod.viewModel.isSignedIn = (csod.context.user > 0);
            resolve();
        });
    },
    events: {
        onCFMainSearchDropdownChange: function (selectedOptions) {
            var filterSection = csod.viewModel.filters.find(function (fs) { return fs.id == csod.viewModel.cfMainSearchDropdownId; });
            if (filterSection) {
                csod.viewModel.cfLastSearchedFilterSnapshot = filterSection;
            }
            if (csod.viewModel.cfMainSearchDropdownId != -1) {
                csod.viewModel.cfMainSearchDropDownOptions.forEach(function (option) {
                    option.isChecked = false;
                });
                if (selectedOptions[0] !== "") {
                    selectedOptions.forEach(function (optionkey) {
                        csod.viewModel.cfMainSearchDropDownOptions.find(function (o) { return o.value === +optionkey; }).isChecked = true;
                    });
                }
            }
        },
        onFilterFlagCloseClick: function (flag) {
            resetLastSelectedFilters();
            if (flag.type === models_1.FilterType.CustomFieldDropdown) {
                var filter = csod.viewModel.filters.find(function (f) { return f.id === flag.filterId; });
                var defaultFilter = csod.viewModel.defaultFilters.find(function (f) { return f.id === flag.filterId; });
                if (filter) {
                    var filterOption = filter.options.find(function (opt) { return opt.Id === flag.id; });
                    var defaultFilterOption = defaultFilter.options.find(function (opt) { return opt.Id === flag.id; });
                    if (filterOption) {
                        filterOption.isChecked = false;
                    }
                    if (defaultFilterOption) {
                        defaultFilterOption.isChecked = false;
                    }
                    var mainSearchOption = csod.viewModel.cfMainSearchDropDownOptions.find(function (opt) { return opt.value === flag.id; });
                    if (mainSearchOption) {
                        mainSearchOption.isChecked = false;
                    }
                }
                else {
                    var selectedFilter = csod.viewModel.selectedFilters.find(function (sf) { return sf.id === flag.filterId; });
                    if (selectedFilter) {
                        updteSelectedFilter(selectedFilter, flag);
                    }
                    return;
                }
            }
            else if (flag.type === models_1.FilterType.CustomFieldRadio) {
                var filter = csod.viewModel.filters.find(function (f) { return f.id === flag.filterId; });
                if (filter) {
                    filter.selectedValue = '';
                }
                else {
                    var selectedFilter = csod.viewModel.selectedFilters.find(function (sf) { return sf.id === flag.filterId; });
                    if (selectedFilter) {
                        updteSelectedFilter(selectedFilter, flag);
                    }
                    return;
                }
            }
            else {
                var filter = csod.viewModel.filters.find(function (f) { return f.filterName === flag.type; });
                if (filter) {
                    var filteroption = filter.options.find(function (opt) { return opt.Id === flag.id; });
                    if (filteroption) {
                        filteroption.isChecked = false;
                    }
                    if (filter.filterName === models_1.FilterType.DatePosted || filter.filterName === models_1.FilterType.Distance) {
                        filter.selectedValue = searchFilterMapper.getDefaultKey(filter.filterName);
                    }
                }
                else {
                    var selectedFilter = csod.viewModel.selectedFilters.find(function (sf) { return sf.filterType === flag.type; });
                    if (selectedFilter) {
                        updteSelectedFilter(selectedFilter, flag);
                    }
                    return;
                }
            }
            setSelectedFilters();
            runNewSearch();
        },
        onCustomFieldDropdownSingleSelectChange: function (optionKey, SectionIndex) {
            var filterSection = csod.viewModel.filters[SectionIndex];
            filterSection.hasChanged = true;
            filterSection.options.forEach(function (option) {
                option.isChecked = parseInt(option.Id) === parseInt(optionKey);
            });
            if (filterSection.id === csod.viewModel.cfMainSearchDropdownId) {
                csod.viewModel.cfMainSearchDropDownOptions.forEach(function (option) {
                    option.isChecked = option.value === +optionKey;
                });
            }
            if (+optionKey === 0) {
                resetLastSelectedFilters();
            }
            else {
                csod.viewModel.lastSelectedFilter = filterSection;
                csod.viewModel.cfLastSearchedFilterSnapshot = filterSection;
            }
            setSelectedFilters();
            csod.viewModel.isDesktop && runNewSearch();
        },
        onDropdownSelect: function (e) {
        },
        toggleRichText: function () {
            csod.viewModel.headerData.isAdvanced = !csod.viewModel.headerData.isAdvanced;
            csod.engine.commit();
        },
        toggleMenu: function () {
            csod.viewModel.siteSettings.showToolbar = !csod.viewModel.siteSettings.showToolbar;
            csod.engine.commit();
        },
        onSearchClick: function () {
            var activeElement = document.activeElement;
            var msddOptionsCopy = JSON.parse(JSON.stringify(csod.viewModel.cfMainSearchDropDownOptions));
            csod.viewModel.IS_FIRST_LOAD = true;
            resetfilters();
            resetQueryParams();
            updateDropdownCustomFields(msddOptionsCopy);
            updateFilterFlags();
            setTimeout(function () {
                if (activeElement && typeof activeElement.focus === 'function') {
                    activeElement.focus();
                }
                else {
                    var searchButton = document.querySelector('.p-search-module button');
                    if (searchButton) {
                        searchButton.focus();
                    }
                }
            });
            runNewSearch();
        },
        onLocationSearch: function () {
            runNewSearch();
        },
        onLocationSearchChange: function (id, query) {
            csod.viewModel.searchBanner.currentLocationQuery = query;
            if (query == "") {
                csod.viewModel.searchBanner.placeId = "";
                csod.engine.commit();
            }
        },
        onLocationSearchPredict: function (id, query) {
            doLocationSearch(query);
        },
        onLocationSearchSelect: function (id, _a) {
            var value = _a.value;
            csod.viewModel.searchBanner.placeId = value.placeId;
            csod.viewModel.searchBanner.currentLocationQuery = value.name;
        },
        onKeywordSearch: function () {
            runNewSearch();
        },
        onKeywordSearchChange: function (id, query) {
            csod.viewModel.searchBanner.currentKeywordQuery = query;
        },
        onKeywordSearchPredict: function (id, query) {
            doKeywordPredictiveSearch(query);
        },
        onKeywordSearchSelect: function (id, _a) {
            var value = _a.value;
            csod.viewModel.searchBanner.currentKeywordQuery = value.a;
        },
        onPrev: function () {
            console.log('onPrev');
        },
        onNext: function () {
            console.log('onNext');
        },
        onCreateJobAlertBtnClick: function () {
            if (!csod.viewModel.hasJobSearchOrFilterApplied) {
                csod.viewModel.jobAlert.showFilterValidationErrorModal = true;
            }
            else if (!csod.viewModel.isSignedIn) {
                var searchUrl = "" + careerSiteUrlProvider.getRoutePrefix() + window.location.search;
                searchUrl = searchUrl.includes('&alert=1') ? searchUrl : searchUrl + '&alert=1';
                var encodedSearchUrl = encodeURIComponent(searchUrl);
                window.location.href = careerSiteUrlProvider.getLoginUrl(encodedSearchUrl);
            }
            else {
                if (csod.viewModel.userEmail == "") {
                    csod.viewModel.jobAlert.showEmailValidationErrorModal = true;
                }
                else {
                    loadCreateFilterDialog();
                }
            }
        },
        onCreateJobAlert: function () {
            if (!csod.viewModel.jobAlert.title) {
                csod.viewModel.jobAlert.titleErrorMsg = csod.viewModel.jobAlert.titleErrorMsgTranslation;
                return;
            }
            var careerSiteSearchUrl = "" + careerSiteUrlProvider.getPrefix() + window.location.search;
            careerSiteSearchUrl = careerSiteSearchUrl.includes('&alert=1') ? careerSiteSearchUrl.replace('&alert=1', '') : careerSiteSearchUrl;
            var queryParams = initStateFromQueryParams();
            var radiusFilter = csod.viewModel.selectedFilters.find(function (f) { return f.filterType == models_1.FilterType.Distance; });
            var radius = getSearchRadius(radiusFilter && radiusFilter.keys);
            var daysPostedWithIn = getDaysPostedWithin(queryParams.date);
            var request = mapping.buildJobAlertRequest(parseInt(csod.viewModel.jobAlert.selectedFrequency, 10), csod.viewModel.jobAlert.title, parseInt(csodPlayerRouteInfo.cid, 10), queryParams.searchQuery, queryParams.state, queryParams.country, queryParams.city, csod.viewModel.siteSettings.currentLanguageDetail, queryParams.placeId, radius, daysPostedWithIn, queryParams.selectedCustomCheckboxFilter, queryParams.selectedCustomDropDownFilters, queryParams.selectedCustomRadioFilters, careerSiteSearchUrl);
            closeJobAlertModal();
            mapping.saveJobAlert(request).then(function () {
                var profileUrl = csod.viewModel.profileUrl + "&activeView=MyAlerts";
                csod.notify['successWithLink'](csod.locales.get('Your job alert has been successfully created.', 'Your job alert has been successfully created.'), csod.locales.get('Click here to manage it', 'Click here to manage it'), profileUrl, function () {
                    window.location.href = profileUrl;
                }, { timeOut: 7000 });
            }).catch(function () {
                csod.notify.error(csod.locales.get('Sorry, an error occurred and job alert could not be created.', 'Sorry, an error occurred and job alert could not be created.'));
            });
            ;
        },
        onJobAlertTitleChange: function (value) {
            csod.viewModel.jobAlert.title = value;
            csod.viewModel.jobAlert.titleErrorMsg = csod.viewModel.jobAlert.title ? '' : csod.viewModel.jobAlert.titleErrorMsgTranslation;
        },
        onCloseJobAlertModal: function () {
            closeJobAlertModal();
        },
        onJobAlertFrequencyChange: function (value, id) {
            csod.viewModel.jobAlert.selectedFrequency = value;
        },
        onCancelJobAlertCreation: function () {
            closeJobAlertModal();
        },
        onCloseEmailValidationErrorModal: function () {
            closeEmailValidationErrorModal();
        },
        onCloseFilterValidationErrorModal: function () {
            closeFilterValidationErrorModal();
        },
        onSortSelect: function (value) {
            console.log("Sort Selection Made: " + value);
        },
        onSortOpen: function () {
            console.log("onSortOpen");
        },
        onApply: function () {
            if (csod.viewModel.jobDetails.canUserApply) {
                mapping.getApplicationWorkflowUrl(csod.viewModel.reqId, csodPlayerRouteInfo.cid).then(function (url) {
                    var applyUrlProvider = new ApplyUrl_1.ApplyUrl();
                    var applyUrl = applyUrlProvider.get("" + csod.context.applicationBase + url, document.location);
                    window.location.href = applyUrl.pathname + '?' + applyUrl.search;
                });
            }
        },
        onSave: function () {
            if (!csod.viewModel.isSignedIn) {
                var jobDetailUrl = careerSiteUrlProvider.getMobileFriendlyJobDetailUrl(csod.viewModel.reqId);
                var encodedJobDetailUrl = encodeURIComponent(jobDetailUrl);
                window.location.href = careerSiteUrlProvider.getLoginUrl(encodedJobDetailUrl);
            }
            else {
                mapping.saveJob(csod.viewModel.reqId).then(function (response) {
                    if (response) {
                        csod.viewModel.jobDetails.isSaveJobDisabled = true;
                        csod.viewModel.jobDetails.saveJobText = csod.locales.get("Job Saved", "Job Saved");
                    }
                    else {
                        csod.viewModel.jobDetails.isSaveJobDisabled = false;
                        csod.viewModel.jobDetails.saveJobText = csod.locales.get("Save Job", "Save Job");
                    }
                    csod.engine.commit();
                });
            }
        },
        onShare: function (value) {
            var _a = window.location, origin = _a.origin, pathname = _a.pathname, hash = _a.hash, search = _a.search;
            var modernURL = origin + pathname + hash.replace('#', '') + search;
            switch (value) {
                case "email":
                    var link = shareLinkGetter.getMailtoURI(csod.viewModel.jobDetails.title, modernURL);
                    if (link)
                        window.location.href = link;
                    break;
                case "linkedIn":
                    var modernURLForLinkedInShare = origin + pathname + hash.replace('#', '');
                    var searchParams = new URLSearchParams(window.location.search);
                    if (searchParams.get('c')) {
                        modernURLForLinkedInShare = modernURLForLinkedInShare + "?c=" + searchParams.get('c');
                    }
                    if (searchParams.get('lang')) {
                        modernURLForLinkedInShare = modernURLForLinkedInShare + "&lang=" + searchParams.get('lang');
                    }
                    var randString = randomGenerator.getRandString();
                    var updatedModernURL = (search != undefined && search.length > 0) ? (modernURLForLinkedInShare + "&" + randString) : (modernURLForLinkedInShare + "?" + randString);
                    var linkedInUrl = shareLinkGetter.getLinkedInUri(updatedModernURL, csod.viewModel.jobDetails.title, csod.viewModel.jobDetails.externalDescription, csod.context.user);
                    var newwindow_1 = window.open(linkedInUrl, 'LinkedIn Share Window', 'height=400,width=650,scrollbars=yes,resizable=yes');
                    if (window.requestAnimationFrame) {
                        window.requestAnimationFrame(function (timestamp) { focusNewWindow(newwindow_1); });
                    }
                    break;
                case "Facebook":
                    var applicationHost = window.location.origin + csod.context.applicationBase;
                    var facebookShareUrl = shareLinkGetter.getFacebookShareUrl(csodFacebookAppId, modernURL, applicationHost);
                    var facebookShareWindow = window.open(facebookShareUrl, "Facebook Share Window", 'height=500,width=1000,scrollbars=yes,resizable=yes');
                    if (window.focus) {
                        facebookShareWindow.focus();
                    }
                    break;
                default:
                    console.log(value);
            }
        },
        onInfoWindowClick: function (marker) {
            console.log("clicked an info window with id: ", marker.id);
        },
        onResultPageNavigation: function (pageNumber) {
            csod.viewModel.currentResultPage = pageNumber;
            search();
            scrollToSearchResults(true);
        },
        handleCollapsibleClick: function (event, data, filterSectionIndex) {
            csod.viewModel.filters[filterSectionIndex].isOpen = !csod.viewModel.filters[filterSectionIndex].isOpen;
        },
        onRadioButtonClick: function (value, filterSectionIndex) {
            var filterSection = csod.viewModel.filters[filterSectionIndex];
            filterSection.selectedValue = value;
            csod.viewModel.lastSelectedFilter = filterSection;
            csod.viewModel.cfLastSearchedFilterSnapshot = filterSection;
            if (filterSection.filterName === models_1.FilterType.CustomFieldRadio && value === 0) {
                resetLastSelectedFilters();
            }
            csod.viewModel.filters[filterSectionIndex] = filterSection;
            setSelectedFilters();
            csod.viewModel.isDesktop && runNewSearch();
        },
        onCheckboxClick: function (value, optionIndex, filterSectionIndex) {
            var filterSection = csod.viewModel.filters[filterSectionIndex];
            filterSection.options[optionIndex].isChecked = value;
            csod.viewModel.lastSelectedFilter = filterSection;
            csod.viewModel.cfLastSearchedFilterSnapshot = filterSection;
            if (filterSection.type === DROPDOWN_MULTI_SELECT) {
                if (csod.viewModel.isDesktop) {
                    var defaultFilterSection = csod.viewModel.defaultFilters.find(function (fltr) { return fltr.id === filterSection.id; });
                    defaultFilterSection.options.forEach(function (element) {
                        if (filterSection.options[optionIndex].Id == element.Id) {
                            element.isChecked = value;
                        }
                    });
                    if (filterSection.id === csod.viewModel.cfMainSearchDropdownId) {
                        filterSection.options.forEach(function (option) {
                            var mainDropdownOption = csod.viewModel.cfMainSearchDropDownOptions.find(function (o) { return o.value === option.Id; });
                            if (mainDropdownOption) {
                                mainDropdownOption.isChecked = option.isChecked;
                            }
                        });
                    }
                }
            }
            if (!value) {
                var numOfSelectedOptions_1 = 0;
                filterSection.options.forEach(function (option) {
                    if (option.isChecked) {
                        numOfSelectedOptions_1++;
                    }
                });
                if (numOfSelectedOptions_1 === 0) {
                    resetLastSelectedFilters();
                }
            }
            setSelectedFilters();
            csod.viewModel.isDesktop && runNewSearch();
        },
        onInputChange: function (value, filterSectionIndex) {
            var filterSection = csod.viewModel.filters[filterSectionIndex];
            var defaultfilter = csod.viewModel.defaultFilters.find(function (fltr) { return fltr.id === filterSection.id; });
            filterSection['inputValue'] = value;
            defaultfilter['inputValue'] = value;
            if (value != "") {
                var newOptionList = filterSection.options.filter(function (f) {
                    return new RegExp('^' + value, 'i').test(f.label);
                });
                filterSection.options = newOptionList;
            }
            else {
                var checkedOptions_1 = new Set();
                filterSection.options.forEach(function (element) {
                    if (element.isChecked) {
                        checkedOptions_1.add(element.Id);
                    }
                });
                filterSection.options = defaultfilter.options;
                filterSection.options.forEach(function (element) {
                    if (checkedOptions_1.has(element.Id)) {
                        element.isChecked = true;
                    }
                });
            }
        },
        onResetFilters: function () {
            resetQueryParams();
            resetfilters();
            csod.viewModel.IS_FIRST_LOAD = true;
            csod.viewModel.searchBanner.currentKeywordQuery = '';
            csod.viewModel.searchBanner.currentLocationQuery = '';
            setSearchBannerInputValues('', '');
            csod.viewModel.searchBanner.placeId = '';
            runNewSearch();
        },
        onFilterApply: function () {
            csod.viewModel.filterFlyoutIsOpen = false;
            updateDropdownCustomFieldsMobile();
            runNewSearch();
        },
        onFilterCancel: function () {
            csod.viewModel.filterFlyoutIsOpen = false;
            csod.viewModel.filters = JSON.parse(JSON.stringify(csod.viewModel.tempFilters));
            csod.viewModel.selectedFilters = JSON.parse(JSON.stringify(csod.viewModel.tempSelectedFilters));
        },
        onOpenFilterFlyout: function () {
            csod.viewModel.filterFlyoutIsOpen = true;
            csod.viewModel.tempFilters = JSON.parse(JSON.stringify(csod.viewModel.filters));
            csod.viewModel.tempSelectedFilters = JSON.parse(JSON.stringify(csod.viewModel.selectedFilters));
        },
        onBreakpoint: function (breakpoint) {
            csod.viewModel.isDesktop = !(breakpoint === 'Xs' || breakpoint === 'Min');
            var paginationSize = {
                'Min': 3,
                'Xs': 3,
                'Sm': 5,
                'Md': 5,
                'Lg': 5,
                'Xl': 5
            };
            csod.viewModel.searchResultsNumberOfPagesShownInPagination = paginationSize[breakpoint];
            setTimeout(function () {
                setSearchBannerHeight();
                setJobDetailsBannerHeight();
            }, 300);
        },
        setSearchBannerContentHeight: function (ref) {
            csod.viewModel.searchBannerContentRef = ref;
            setTimeout(function () {
                setSearchBannerHeight();
            }, 300);
        },
        setJobDetailsBannerContentHeight: function (ref) {
            csod.viewModel.jobDetailsBannerContentRef = ref;
            setTimeout(function () {
                setJobDetailsBannerHeight();
            }, 300);
        },
        onReturnFromDetailPage: function () {
            if (csod.viewModel.scrollToResultsFromDetails) {
                scrollToSearchResults(false);
            }
            setSearchBannerHeight();
            document.title = csod.locales.get('Current Openings', 'Current Openings') + ' - ' + csod.context.corp;
        }
    }
};
var focusNewWindow = function (newWindow) {
    newWindow.focus();
};
var scrollToSearchResults = function (useSmoothScroll) {
    scrollToElement('.p-view-jobsearchresults', useSmoothScroll);
    csod.viewModel.scrollToResultsFromDetails = false;
    csod.engine.commit();
};
var scrollToJobDetails = function () {
    scrollToElement('.p-view-jobdetails', false);
};
var scrollToElement = function (elementQuerySelector, useSmoothScroll) {
    var element = document.querySelector(elementQuerySelector);
    if (element) {
        var offset_1 = {
            left: 0,
            top: player_scroll_to_1.getOffset(element).top
        };
        setTimeout(function () {
            if (useSmoothScroll) {
                player_scroll_to_1.smoothScroll(offset_1);
            }
            else {
                window.scrollTo(0, offset_1.top);
            }
        }, 300);
    }
};
var setSearchBannerHeight = function () {
    csod.viewModel.searchBannerContentHeight = csod.viewModel.searchBannerContentRef ? csod.viewModel.searchBannerContentRef.clientHeight : 0;
    csod.engine.commit();
};
var setLanguageAttribute = function (lang) {
    document.getElementsByTagName('html')[0].setAttribute("lang", lang);
};
var setLanguageAsQueryStringParameter = function () {
    var url = careerSiteUrlProvider.setLanguageAsQueryStringParameter(window.location.href, csod.viewModel.siteSettings.currentLanguageDetail.cultureName);
    window.location.href = url;
};
var setJobDetailsBannerHeight = function () {
    csod.viewModel.jobDetailsBannerContentHeight = csod.viewModel.jobDetailsBannerContentRef ? csod.viewModel.jobDetailsBannerContentRef.clientHeight : 0;
    csod.engine.commit();
};
var refreshCultures = function () {
    return csod.locales.setLocalesCulture(csod.viewModel.siteSettings.currentLanguageDetail.cultureName)
        .then(function () {
        localize();
    });
};
var getCurrentCultureId = function () {
    var cultureId = null;
    if (csod.viewModel.siteSettings != null && csod.viewModel.siteSettings.currentLanguage != "0") {
        cultureId = csod.viewModel.siteSettings.currentLanguage;
    }
    else {
        cultureId = csod.context.cultureID.toString();
    }
    return cultureId;
};
var localize = function () {
    languageSetter.setLocalizedValues(csod.viewModel.siteSettings.allowedLanguages);
    csod.viewModel.languageSetterLabel = csod.locales.get('Change Language', 'Change Language');
    csod.viewModel.signInText = csod.locales.get('Sign In', 'Sign In');
    csod.viewModel.signOutText = csod.locales.get('Sign Out', 'Sign Out');
    csod.viewModel.myProfileText = csod.locales.get('My Profile', 'My Profile');
    csod.viewModel.createProfileText = csod.locales.get('Create Profile', 'Create Profile');
    csod.viewModel.searchBanner.keywordSearchPlaceholder = csod.locales.get("Enter a job title or keyword", "Enter a job title or keyword");
    csod.viewModel.searchBanner.keywordSearchAriaLabel = csod.locales.get("Enter a job title or keyword to search", "Enter a job title or keyword to search");
    csod.viewModel.searchBanner.keywordSearchNoResults = csod.locales.get("No Results", "No Results");
    csod.viewModel.searchBanner.locationSearchPlaceholder = csod.locales.get("Location", "Location");
    csod.viewModel.searchBanner.locationSearchNoResults = csod.locales.get("No Results", "No Results");
    csod.viewModel.searchBanner.buttonText = csod.locales.get("Search", "Search");
    csod.viewModel.navigation.backText = csod.locales.get('Back to Search', 'Back to Search');
    csod.viewModel.navigation.prevText = csod.locales.get('Previous Job', 'Previous Job');
    csod.viewModel.navigation.nextText = csod.locales.get('Next Job', 'Next Job');
    csod.viewModel.jobSearchMap.loadingText = csod.locales.get('Loading...', 'Loading...');
    csod.viewModel.resetText = csod.locales.get('Reset', 'Reset');
    csod.viewModel.applyText = csod.locales.get('Apply', 'Apply');
    csod.viewModel.cancelText = csod.locales.get('Cancel', 'Cancel');
    csod.viewModel.filtersText = csod.locales.get('Filters', 'Filters');
    csod.viewModel.openFilterFlyoutText = csod.locales.get('RefineSearch', 'Refine Search');
    csod.viewModel.signText = csod.viewModel.isSignedIn ? csod.viewModel.signOutText : csod.viewModel.signInText;
    csod.viewModel.profileText = csod.viewModel.isSignedIn ? csod.viewModel.myProfileText : csod.viewModel.createProfileText;
    csod.viewModel.shareBtnText = csod.locales.get("Share", "Share");
    csod.viewModel.shareOptions[0].label = csod.locales.get('Email', 'Email');
    csod.viewModel.shareOptions[0].title = csod.locales.get('Email', 'Email');
    csod.viewModel.shareOptions[1].label = csod.locales.get('LinkedIn', 'LinkedIn');
    csod.viewModel.shareOptions[1].title = csod.locales.get('LinkedIn', 'LinkedIn');
    csod.viewModel.shareOptions[2].label = csod.locales.get('Facebook', 'Facebook');
    csod.viewModel.shareOptions[2].title = csod.locales.get('Facebook', 'Facebook');
    csod.viewModel.jobAlert.titleCaption = csod.locales.get('Name', 'Name');
    csod.viewModel.jobAlert.frequencyCaption = csod.locales.get('Cadence', 'Cadence');
    csod.viewModel.jobAlert.modalTitle = csod.locales.get('Create an alert', 'Create an alert');
    csod.viewModel.jobAlert.modalInstruction = csod.locales.get('And get notified by email as soon as a job matches with your criteria.', 'And get notified by email as soon as a job matches with your criteria.');
    csod.viewModel.jobAlert.frequency[0].label = csod.locales.get('Daily', 'Daily');
    csod.viewModel.jobAlert.frequency[1].label = csod.locales.get('Weekly', 'Weekly');
    csod.viewModel.jobAlert.createBtnText = csod.locales.get('Create', 'Create');
    csod.viewModel.jobAlert.cancelBtnText = csod.locales.get('Cancel', 'Cancel');
    csod.viewModel.jobAlert.titleErrorMsgTranslation = csod.locales.get('Name is required', 'Name is required');
    csod.viewModel.jobAlert.yourCriteriaCaption = csod.locales.get('Your criteria', 'Your criteria');
    csod.viewModel.cfDefaultDropdownText = csod.locales.get('Clear Selection', 'Clear Selection');
    csod.viewModel.cfDefaultRadioButtonText = csod.locales.get('Clear Selection', 'Clear Selection');
    csod.viewModel.jobAlert.emailValidationErrorModalTitle = csod.locales.get('Cannot create an alert', 'Cannot create an alert');
    csod.viewModel.jobAlert.emailValidationErrorModalText = csod.locales.get('You must update your profile and provide an e-mail address before setting up an alert', 'You must update your profile and provide an e-mail address before setting up an alert.');
    csod.viewModel.jobAlert.closeBtnText = csod.locales.get('Close', 'Close');
    csod.viewModel.jobAlert.filterValidationErrorModalTitle = csod.locales.get('Create an alert', 'Create an alert');
    csod.viewModel.jobAlert.filterValidationErrorModalText = csod.locales.get('CreateAlertModalMessageForFilterValidation', 'You\'ll need to apply at least one search or filter before creating a job alert.');
};
var loadSiteSettings = function (cultureId, url, callback) {
    if (csod.viewModel.siteSettings.currentLanguage == 0) {
        return mapping.bootstrap(csodPlayerRouteInfo.cid, cultureId)
            .then(populateSiteSettings)
            .then(transformCustomFieldFilters)
            .then(callback)
            .then(function () { return Promise.all([
            updateSignStatusURLs(url),
            populateInitialResults()
        ]); })
            .then(function () { return csod.engine.commit(); });
    }
    else
        return Promise.all([
            search(),
            callback(),
            updateSignStatusURLs(url)
        ])
            .then(function () { return csod.engine.commit(); });
};
var setUserEmail = function () {
    return mapping.getUserEmail().then(function (response) {
        csod.viewModel.userEmail = response;
    });
};
var populateSiteSettings = function () {
    return mapping.getSiteData().then(function (data) {
        var initParams = initStateFromQueryParams();
        if (initParams.hideCustomHeaderAndFooter !== 'true') {
            csod.viewModel.headerData = Object.assign(csod.viewModel.headerData, data.header);
            csod.viewModel.footerData = Object.assign(csod.viewModel.footerData, data.footer);
            csod.viewModel.headerData.imageAlt = csod.locales.get('career.site.logo.home', 'Career Site Logo - Home');
            csod.viewModel.footerData.imageAlt = csod.locales.get('career.site.logo.home', 'Career Site Logo - Home');
        }
        csod.viewModel.siteSettings = Object.assign(csod.viewModel.siteSettings, data.settings);
        csod.viewModel.searchBanner = Object.assign(csod.viewModel.searchBanner, data.searchBanner);
        csod.viewModel.CustomFieldsObjects = data["customFields"];
        if (csod.viewModel.CustomFieldsObjects && csod.viewModel.CustomFieldsObjects.length) {
            csod.viewModel.customFieldIds = data["customFields"].map(function (f) { return f.fieldId; });
        }
        csod.viewModel.searchBanner.bannerImagePath = data.searchBanner.bannerImagePath[0];
        csod.viewModel.companyInformationHtml = data.companyInformationHtml;
        csod.viewModel.siteSettings.currentLanguage = data.settings.currentLanguage.cultureId;
        csod.viewModel.siteSettings.currentLanguageDetail = data.settings.currentLanguage;
        csod.viewModel.jobDetailsBannerPath = data.jobDetailsBannerImagePath;
        csod.viewModel.isJobAlertsEnabled = data.settings.isJobAlertsEnabled;
        document.documentElement.dir = (data.settings.currentLanguage.isRightToLeft) ? "rtl" : "ltr";
        if (window.location.href.indexOf('requisition') === -1) {
            document.title = csod.locales.get('Current Openings', 'Current Openings') + ' - ' + csod.context.corp;
        }
        localStorage.setItem("RCECultureId", data.settings.currentLanguage.cultureId.toString());
        localStorage.setItem("RCECultureName", data.settings.currentLanguage.cultureName);
        loadMapsApiLib();
    }).then(refreshCultures);
};
var getCareerSiteDisplayPostingEndDate = function () {
    return mapping.getCorpSettingValue("CareerSiteDisplayPostingEndDate").then(function (data) {
        csod.viewModel.isCareerSiteDisplayPostingEndDateEnabled = data;
    });
};
var getPostingDateInJobDetailsPage = function () {
    return mapping.getCorpSettingValue("PostingDateInJobDetailsPage").then(function (data) {
        csod.viewModel.isPostingDateInJobDetailsPageEnabled = data;
    });
};
var getExternalCareerSiteDisplayKilometerFilter = function () {
    return mapping.getCorpSettingValue("ExternalCareerSiteDisplayKilometerFilter").then(function (data) {
        csod.viewModel.isExternalCareerSiteDisplayKilometerFilterEnabled = data;
    });
};
var getEnableCountryStateCityFilterMFC = function () {
    return mapping
        .getCorpSettingValue("EnableCountryStateCityFilterMFC")
        .then(function (data) {
        csod.viewModel.isEnableCountryStateCityFilterMFCEnabled = data;
    });
};
var getEnableAllValuesForCustomFieldInMFC = function () {
    return mapping
        .getCorpSettingValue("EnableAllValuesForCustomFieldInMFC")
        .then(function (data) {
        csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled = String(data).toLowerCase() === "true";
    });
};
var loadMapsApiLib = function () {
    var mapsApiKey = csodGoogleMapsClientApi.key;
    var mapsIsPremium = JSON.parse(csodGoogleMapsClientApi.isPremium.toLocaleLowerCase());
    var url = "https://maps.googleapis.com/maps/api/js?";
    if (mapsIsPremium) {
        url += "client=" + mapsApiKey + "&channel=ats&libraries=places";
    }
    else {
        url += "key=" + mapsApiKey + "&libraries=places";
    }
    csod.loader.loadScriptByUrl(url).then(function (response) {
        csod.viewModel.mapsApiLoaded = true;
        csod.viewModel.mapsApiService = new google.maps.places.AutocompleteService();
    }).catch(function (error) {
        console.log('gmaps error: ' + error);
    });
};
var updateSignStatusURLs = function (returnUrl) {
    var _a = csod.viewModel, isSignedIn = _a.isSignedIn, signInText = _a.signInText, signOutText = _a.signOutText, myProfileText = _a.myProfileText, createProfileText = _a.createProfileText, siteSettings = _a.siteSettings;
    var encodedReturnUrl = encodeURIComponent(returnUrl);
    signStatusSetter.updateSignStatus(csod.viewModel, csod.context.applicationBase, csod.context.corp, csodPlayerRouteInfo.cid, encodedReturnUrl, csod.viewModel.siteSettings.currentLanguageDetail.cultureName);
};
var populateInitialResults = function () {
    return Promise.resolve(mapping.getInitialJobResults().then(function (data) {
        var queryParams = initStateFromQueryParams();
        var radius = getSearchRadius(queryParams.distance);
        var daysPostedWithIn = getDaysPostedWithin(queryParams.date);
        var searchData = mapping.buildSearchRequest(parseInt(csodPlayerRouteInfo.cid, 10), csod.viewModel.currentResultPage, csod.viewModel.resultPageSize, queryParams.searchQuery, queryParams.state, queryParams.country, queryParams.city, csod.viewModel.siteSettings.currentLanguageDetail, queryParams.placeId, radius, daysPostedWithIn, queryParams.selectedCustomCheckboxFilter, queryParams.selectedCustomDropDownFilters, queryParams.selectedCustomRadioFilters);
        if (!searchData.searchText && window.location.href.indexOf("requisition") > 0) {
            searchData.searchText = csod.viewModel.jobDetails.ref;
        }
        return Promise.resolve(getNewResults(searchData, true, queryParams.alert));
    }));
};
var getOuLocations = function () {
    if (csod.viewModel.isEnableCountryStateCityFilterMFCEnabled.toLocaleLowerCase() == "true") {
        return mapping.getOuLocations().then(function (data) {
            csod.viewModel.ouLocations = data;
        });
    }
    return Promise.resolve();
};
var getNewResults = function (searchData, setDefault, setAlert) {
    if (setDefault === void 0) { setDefault = false; }
    if (setAlert === void 0) { setAlert = false; }
    csod.viewModel.nonCustomFieldParams = getNonCustomFieldParams();
    csod.viewModel.isLoading = true;
    return mapping.getNewJobResults(searchData).then(function (data) {
        csod.viewModel.totalSearchResults = data.totalSearchResults;
        csod.viewModel.searchResults = data.results;
        csod.viewModel.totalResultPages = Math.ceil(data.totalSearchResults / searchData.pageSize);
        setDefault && setDefaultFilters(data.filters);
        if (csod.viewModel.CustomFieldsObjects && csod.viewModel.CustomFieldsObjects.length) {
            var customFieldCheckboxes = [];
            var checkboxFilters = AddCustomFieldCheckboxFilters(data.customFieldFilters);
            if (checkboxFilters && checkboxFilters.items && checkboxFilters.items.length > 0) {
                customFieldCheckboxes.push(checkboxFilters);
                customFieldCheckboxes.forEach(function (element) {
                    data.filters.push(element);
                });
            }
            csod.viewModel.CustomFields.forEach(function (element) {
                if (element.displayType === models_1.CustomFieldItemType.Dropdown) {
                    if (element.includeInMainSearch) {
                        AddCusomFildDropdownToMainSearch(element);
                        csod.viewModel.hasCFMainSearch = true;
                        csod.viewModel.cfMainIsMultiselect = element.allowMultiSelect;
                        csod.viewModel.cfMainSearchDropdownId = element.fieldId;
                    }
                    var dropDownFilter = AddCustomFieldDropdownFilters(element, element.allowMultiSelect, data.customFieldFilters);
                    if (dropDownFilter && dropDownFilter.items && dropDownFilter.items.length > 0) {
                        data.filters.push(dropDownFilter);
                    }
                }
                if (element.displayType === models_1.CustomFieldItemType.Radiobutton) {
                    var radioFilter = AddCustomFieldRadioFilter(element, data.customFieldFilters);
                    if (radioFilter) {
                        data.filters.push(radioFilter);
                    }
                }
            });
        }
        transformFilters(data.filters);
        if (csod.viewModel.IS_FIRST_LOAD) {
            csod.viewModel.defaultFilters = JSON.parse(JSON.stringify(csod.viewModel.filters));
            csod.viewModel.IS_FIRST_LOAD = false;
        }
        else if (csod.viewModel.cfFilterToResetOptions.length) {
            csod.viewModel.cfFilterToResetOptions.forEach(function (optionId) {
                var defaultFilter = csod.viewModel.defaultFilters.find(function (fltr) { return fltr.id === optionId; });
                var filter = csod.viewModel.filters.find(function (fltr) { return fltr.id === optionId; });
                if (defaultFilter && filter) {
                    defaultFilter.options = JSON.parse(JSON.stringify(filter.options));
                }
            });
            csod.viewModel.cfFilterToResetOptions = [];
        }
        setSelectedFilters();
        updateQueryParams();
        csod.viewModel.isLoading = false;
        csod.engine.commit();
        setAlertBtnVisibilityOnSearch(searchData);
        if (csod.viewModel.hasJobSearchOrFilterApplied && setAlert && csod.viewModel.isSignedIn)
            loadCreateFilterDialog();
    })
        .catch(function (err) {
        console.log(err);
        csod.viewModel.isLoading = false;
    });
};
var loadCreateFilterDialog = function () {
    var countryFilter = getFilter(models_1.FilterType.Country).keys;
    var stateFilter = getFilter(models_1.FilterType.State).keys;
    var cityFilter = getFilter(models_1.FilterType.City).keys;
    var datePostedFilter = getFilter(models_1.FilterType.DatePosted).keys;
    var radiusFilter = csod.viewModel.selectedFilters.find(function (f) { return f.filterType == models_1.FilterType.Distance; });
    var customFilters = getAllCustomFilters();
    var criteria = [];
    if (csod.viewModel.searchBanner.currentKeywordQuery) {
        var currentKeywordQuery = {
            title: csod.locales.get("Keyword", "Keyword") + ": ",
            value: csod.viewModel.searchBanner.currentKeywordQuery,
        };
        criteria.push(currentKeywordQuery);
    }
    if (csod.viewModel.searchBanner.currentLocationQuery) {
        var currentLocationQuery = {
            title: csod.locales.get("Location", "Location") + ": ",
            value: csod.viewModel.searchBanner.currentLocationQuery,
        };
        criteria.push(currentLocationQuery);
    }
    if (countryFilter.length > 0) {
        var currentKeywordQuery = {
            title: csod.locales.get("Country", "Country") + ": ",
            value: getLocalizedTitles(countryFilter, models_1.FilterType.Country),
        };
        criteria.push(currentKeywordQuery);
    }
    if (stateFilter.length > 0) {
        var currentKeywordQuery = {
            title: csod.locales.get("State / Province", "State / Province") + ": ",
            value: getLocalizedTitles(stateFilter, models_1.FilterType.State),
        };
        criteria.push(currentKeywordQuery);
    }
    if (cityFilter.length > 0) {
        var currentKeywordQuery = {
            title: csod.locales.get("City", "City") + ": ",
            value: getLocalizedTitles(cityFilter, models_1.FilterType.City),
        };
        criteria.push(currentKeywordQuery);
    }
    if (datePostedFilter.length > 0) {
        var currentKeywordQuery = {
            title: csod.locales.get("Date Posted", "Date Posted") + ": ",
            value: getLocalizedTitles(datePostedFilter, models_1.FilterType.DatePosted),
        };
        criteria.push(currentKeywordQuery);
    }
    if (radiusFilter && radiusFilter.keys) {
        var radiusText = getLocalizedDistances(radiusFilter.keys[0]);
        var currentKeywordQuery = {
            title: csod.locales.get("Distance", "Distance") + ": ",
            value: radiusText,
        };
        criteria.push(currentKeywordQuery);
    }
    customFilters.forEach(function (cfd) {
        if (cfd.title !== undefined && cfd.keys.length > 0 && !(cfd.keys.includes("") || cfd.keys.includes(null) || cfd.keys.includes(0))) {
            var customField = {
                title: csod.locales.get(cfd.title, cfd.title) + ": ",
                value: getLocalizedTitlesForCustomFields(cfd.keys, cfd.filterType, cfd.id),
            };
            criteria.push(customField);
        }
    });
    if (criteria.length > 0) {
        csod.viewModel.jobAlert.criteria = criteria;
        csod.viewModel.jobAlert.showCreateModal = true;
    }
    var jobAlertDialog = document.getElementById("createJobAlertModal");
    if (jobAlertDialog) {
        var focusableElements = jobAlertDialog.querySelectorAll('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
        if (focusableElements.length > 0) {
            var firstFocusable_1 = focusableElements[0];
            var lastFocusable_1 = focusableElements[focusableElements.length - 1];
            jobAlertDialog.addEventListener('keydown', function (event) {
                if (event.key === 'Tab') {
                    if (event.shiftKey) {
                        if (document.activeElement === firstFocusable_1) {
                            event.preventDefault();
                            lastFocusable_1.focus();
                        }
                    }
                    else {
                        if (document.activeElement === lastFocusable_1) {
                            event.preventDefault();
                            firstFocusable_1.focus();
                        }
                    }
                }
            });
        }
    }
};
var closeJobAlertModal = function () {
    csod.viewModel.jobAlert.showCreateModal = false;
    csod.viewModel.jobAlert.title = "";
    csod.viewModel.jobAlert.titleErrorMsg = "";
    csod.viewModel.jobAlert.selectedFrequency = "1";
    csod.viewModel.jobAlert.criteria = [];
    if (window.location.href.includes('alert=1')) {
        var url = window.location.href.replace('&alert=1', '').replace('alert=1', '');
        window.history.pushState({ path: url }, '', url);
    }
};
var closeEmailValidationErrorModal = function () {
    csod.viewModel.jobAlert.showEmailValidationErrorModal = false;
};
var closeFilterValidationErrorModal = function () {
    csod.viewModel.jobAlert.showFilterValidationErrorModal = false;
};
var getLocalizedTitles = function (ids, filterType) {
    return csod.viewModel.filters.find(function (f) { return (f.filterName == filterType); }).options.
        filter(function (ob) { return ids.includes(ob.Id); })
        .map(function (x) { return x.LocalizedTitle; })
        .join(', ');
};
var getLocalizedDistances = function (key) {
    return csod.viewModel.isExternalCareerSiteDisplayKilometerFilterEnabled.toLocaleLowerCase() === "true" ? csod.locales.get(key, key) : key;
};
var getLocalizedTitlesForCustomFields = function (ids, filterType, filterId) {
    return csod.viewModel.filters.find(function (f) { return (f.filterName == filterType) && (f.id == filterId); }).options.
        filter(function (ob) { return ids.includes(ob.Id); })
        .map(function (x) { return x.LocalizedTitle; })
        .join(', ');
};
var setAlertBtnVisibilityOnSearch = function (searchRequest) {
    csod.viewModel.hasJobSearchOrFilterApplied = false;
    if (csod.viewModel.isJobAlertsEnabled == false)
        return;
    if (searchRequest.searchText || searchRequest.placeID || searchRequest.radius || searchRequest.postingsWithinDays)
        csod.viewModel.hasJobSearchOrFilterApplied = true;
    else if (searchRequest.countryCodes.length > 0 || searchRequest.states.length > 0 || searchRequest.cities.length > 0)
        csod.viewModel.hasJobSearchOrFilterApplied = true;
    else if (searchRequest.customFieldCheckboxKeys.length > 0 || searchRequest.customFieldDropdowns.length > 0 || searchRequest.customFieldRadios.length > 0)
        csod.viewModel.hasJobSearchOrFilterApplied = true;
};
var resetfilters = function () {
    resetLastSelectedFilters();
    csod.viewModel.selectedFilters = [];
    csod.viewModel.selectedFilterFlaglist = [];
    csod.viewModel.defaultFilters.forEach(function (filter) {
        if (filter.options) {
            if (filter.inputValue) {
                filter.inputValue = '';
            }
            filter.options.forEach(function (option) {
                option.isChecked = false;
            });
        }
    });
    var dropdownFilters = csod.viewModel.filters.filter(function (f) { return f.type === DROPDOWN_MULTI_SELECT; });
    dropdownFilters.forEach(function (filter) {
        filter.inputValue = '';
        var dfilter = csod.viewModel.defaultFilters.find(function (f) { return f.id === filter.id; });
        if (dfilter) {
            filter.options = dfilter.options.slice();
        }
    });
    csod.viewModel.cfMainSearchDropDownOptions.forEach(function (option) {
        option.isChecked = false;
    });
};
var runNewSearch = function () { return __awaiter(_this, void 0, void 0, function () {
    var _a, currentLocationQuery, placeId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = csod.viewModel.searchBanner, currentLocationQuery = _a.currentLocationQuery, placeId = _a.placeId;
                if (!(currentLocationQuery && !placeId)) return [3 /*break*/, 2];
                return [4 /*yield*/, mapping.getLocationSearch(currentLocationQuery, google)
                        .then(function (data) {
                        if (data.results.length) {
                            var value = data.results[0].value;
                            var name = value.name, placeId_1 = value.placeId;
                            csod.viewModel.searchBanner.currentLocationQuery = name;
                            setSearchBannerInputValues(null, name);
                            csod.viewModel.searchBanner.placeId = placeId_1;
                            csod.engine.commit();
                        }
                    })];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                csod.viewModel.currentResultPage = 1;
                search();
                csod.viewModel.hasSearched = true;
                csod.viewModel.isKeywordSearch = (csod.viewModel.searchBanner.currentKeywordQuery) ? true : false;
                scrollToSearchResults(true);
                return [2 /*return*/];
        }
    });
}); };
var getFilter = function (filterType) {
    var selectedFilter = csod.viewModel.selectedFilters.find(function (f) { return f.filterType == filterType; });
    if (selectedFilter !== undefined)
        return selectedFilter;
    return { "keys": [], "isOpen": true, "filterType": filterType };
};
var getCustomFilter = function (filter) {
    var selectedFilters;
    var result = { "keys": [], "isOpen": true, "filterType": filter.filterType };
    if (filter.filterType === models_1.FilterType.CustomFieldDropdown || filter.filterType === models_1.FilterType.CustomFieldRadio || filter.filterType === models_1.FilterType.CustomFieldCheckbox) {
        selectedFilters = csod.viewModel.selectedFilters.filter(function (f) { return f.filterType == filter.filterType; });
        selectedFilters.forEach(function (sf) {
            if (sf.id === filter.id) {
                result = sf;
            }
        });
    }
    return result;
};
var getAllCustomFilters = function () {
    var selectedFilters;
    var result = [];
    selectedFilters = csod.viewModel.selectedFilters.filter(function (f) { return f.filterType == models_1.FilterType.CustomFieldCheckbox || f.filterType == models_1.FilterType.CustomFieldRadio || f.filterType == models_1.FilterType.CustomFieldDropdown; });
    selectedFilters.forEach(function (sf) {
        result.push(sf);
    });
    return result;
};
var getSearchRadius = function (radiusFilter) {
    if (radiusFilter) {
        switch (radiusFilter[0]) {
            case '5 mi': return 5;
            case '10 mi': return 10;
            case '15 mi': return 15;
            case '25 mi': return 25;
            case '50 mi': return 50;
            case '100 mi': return 100;
            default: return null;
        }
    }
    else {
        return null;
    }
};
var getDaysPostedWithin = function (datePostedFilter) {
    if (datePostedFilter) {
        switch (datePostedFilter[0]) {
            case 'WithinOneDay': return 1;
            case 'WithinThreeDays': return 3;
            case 'WithinSevenDays': return 7;
            case 'WithinFifteenDays': return 15;
            case 'WithinThirtyDays': return 30;
            case 'Anytime': return null;
        }
    }
    else {
        return null;
    }
};
var search = function () {
    var careerSiteId = parseInt(csodPlayerRouteInfo.cid, 10);
    var searchText = csod.viewModel.searchBanner.currentKeywordQuery;
    var datePostedFilter = csod.viewModel.selectedFilters.find(function (f) { return f.filterType == models_1.FilterType.DatePosted; });
    var daysPostedWithIn = getDaysPostedWithin(datePostedFilter && datePostedFilter.keys);
    var radiusFilter = csod.viewModel.selectedFilters.find(function (f) { return f.filterType == models_1.FilterType.Distance; });
    var radius = getSearchRadius(radiusFilter && radiusFilter.keys);
    var countryFilter = getFilter(models_1.FilterType.Country).keys;
    var stateFilter = getFilter(models_1.FilterType.State).keys;
    var cityFilter = getFilter(models_1.FilterType.City).keys;
    var selectedCustomCheckboxFilter = getSelectedCustomCheckboxFilters();
    var selectedCustomDropDownFilter = getSelectedCustomDropdownFilters();
    var selectedCustomRadioFilter = getSelectedCustomRadioFilters();
    var searchData = mapping.buildSearchRequest(careerSiteId, csod.viewModel.currentResultPage, csod.viewModel.resultPageSize, searchText, stateFilter, countryFilter, cityFilter, csod.viewModel.siteSettings.currentLanguageDetail, csod.viewModel.searchBanner.placeId, radius, daysPostedWithIn, selectedCustomCheckboxFilter, selectedCustomDropDownFilter, selectedCustomRadioFilter);
    return Promise.resolve(getNewResults(searchData));
};
var populateReqDetails = function () {
    scrollToJobDetails();
    var cultureId = csod.viewModel.siteSettings.currentLanguageDetail.cultureId;
    csod.viewModel.jobDetails.saveJobText = csod.locales.get("Save Job", "Save Job");
    csod.viewModel.isLoading = true;
    csod.engine.commit();
    return getApplyStatusForApplicant().then(function () {
        if (csod.viewModel.jobDetails.isJobAvailableToApply) {
            return Promise.all([
                mapping.getJobAd(csodPlayerRouteInfo.cid, csod.viewModel.reqId, cultureId).then(function (data) {
                    csod.viewModel.jobDetails.jobAd = data;
                }),
                mapping.getJobDetail(csodPlayerRouteInfo.cid, csod.viewModel.reqId, cultureId).then(function (data) {
                    csod.viewModel.jobDetails.title = data.displayTitle ? data.displayTitle : "";
                    csod.viewModel.jobDetails.externalDescription = data.externalDescription ? data.externalDescription : "";
                    csod.viewModel.jobDetails.ref = data.ref;
                    csod.viewModel.jobDetails.additionalLocations = data.additionalLocations;
                    csod.viewModel.jobDetails.primaryLocation = data.primaryLocation;
                    if (csod.viewModel.jobDetails.additionalLocations.length) {
                        csod.viewModel.allLocations = jobDetailProvider.getLocationsWithDisplayTitle(csod.viewModel.jobDetails);
                        csod.viewModel.hasAdditionalLocations = true;
                        csod.engine.commit();
                    }
                    else {
                        csod.viewModel.hasAdditionalLocations = false;
                    }
                    csod.viewModel.locationDisplay = jobDetailProvider.getLocationTitle(csod.viewModel.jobDetails);
                }),
                getSaveJobStatus(csod.viewModel.reqId)
            ])
                .catch(function (error) {
                console.log(error);
            })
                .then(function () { csod.engine.commit(); });
        }
    })
        .then(function () {
        setJobDetailsBannerHeight();
        csod.viewModel.isLoading = false;
        if (csod.viewModel.jobDetails.title) {
            document.title = csod.viewModel.jobDetails.title + ' | ' + csod.locales.get('Job Details', 'Job Details');
        }
        csod.engine.commit();
    });
};
var getSelectedCustomCheckboxFilters = function () {
    var selectedFilter = csod.viewModel.selectedFilters.find(function (f) { return f.filterType == models_1.FilterType.CustomFieldCheckbox; });
    if (selectedFilter !== undefined) {
        return selectedFilter.keys;
    }
    return [];
};
var getSelectedCustomDropdownFilters = function () {
    var dropdowns = csod.viewModel.selectedFilters.filter(function (f) { return f.filterType == models_1.FilterType.CustomFieldDropdown; });
    var selected = [];
    if (dropdowns) {
        dropdowns.forEach(function (element) {
            if (element.keys.length && +element.keys[0] !== 0 && csod.viewModel.CustomFields.has(element.id)) {
                var cf = csod.viewModel.CustomFields.get(element.id);
                selected.push({
                    id: cf.fieldId,
                    options: element.keys.slice()
                });
            }
        });
    }
    return selected;
};
var getSelectedCustomRadioFilters = function () {
    var radios = csod.viewModel.selectedFilters.filter(function (f) { return f.filterType == models_1.FilterType.CustomFieldRadio; });
    var selected = [];
    if (radios) {
        radios.forEach(function (r) {
            if (r.keys.length && r.keys[0] !== "" && +r.keys[0] !== 0 && csod.viewModel.CustomFields.has(r.id)) {
                var cf = csod.viewModel.CustomFields.get(r.id);
                selected.push({
                    id: cf.fieldId,
                    options: r.keys.slice()
                });
            }
        });
    }
    return selected;
};
var getSaveJobStatus = function (reqId) {
    return mapping.getSavedJob(reqId).then(function (isSaved) {
        csod.viewModel.jobDetails.isSaveJobDisabled = isSaved;
        if (isSaved) {
            csod.viewModel.jobDetails.saveJobText = csod.locales.get("Job Saved", "Job Saved");
        }
        csod.engine.commit();
    });
};
var getApplyStatusForApplicant = function () {
    if (csod.viewModel.jobDetails.applyNowStatusId == -1) {
        return mapping.getApplicantApplyStatus(csodPlayerRouteInfo.cid, csod.viewModel.reqId).then(function (status) {
            csod.viewModel.jobDetails.applyNowStatusId = status;
            updateApplyStatus(status);
        });
    }
    else {
        return Promise.resolve(updateApplyStatus(csod.viewModel.jobDetails.applyNowStatusId));
    }
};
var updateApplyStatus = function (status) {
    if (status == 0) {
        csod.viewModel.jobDetails.isJobAvailableToApply = false;
    }
    else {
        var applyNowButtonSetting = applyStatusGetter.getApplyStatus(status);
        csod.viewModel.jobDetails.applyNowStatusText = applyNowButtonSetting.applyText;
        csod.viewModel.jobDetails.canUserApply = applyNowButtonSetting.canUserApply;
        csod.viewModel.jobDetails.isJobAvailableToApply = true;
    }
};
var doLocationSearch = function (query) {
    csod.viewModel.isLoading = true;
    csod.viewModel.searchBanner.locationSearchPredictions = [];
    mapping.getLocationSearch(query, google).then(function (data) {
        csod.viewModel.searchBanner.locationSearchPredictions = data.results.length ? data.results : null;
        csod.viewModel.isLoading = false;
        csod.viewModel.searchBanner.placeId = '';
        csod.engine.commit();
    });
};
var doKeywordPredictiveSearch = function (query) {
    csod.viewModel.searchBanner.currentKeywordQuery = query;
    csod.viewModel.isLoading = true;
    csod.viewModel.searchBanner.keywordSearchPredictions = [];
    var predictiveSearchRequest = {
        careerSiteId: csodPlayerRouteInfo.cid,
        cultureId: csod.viewModel.siteSettings.currentLanguageDetail.cultureId,
        searchText: query,
    };
    mapping.getKeywordPredictiveSearchResults(predictiveSearchRequest).then(function (suggestions) {
        var predictions = suggestions.map(function (f, index) {
            var predictionItem = {
                text: f,
                value: {
                    a: f
                }
            };
            return predictionItem;
        });
        csod.viewModel.searchBanner.keywordSearchPredictions = predictions.length ? predictions : [];
        csod.viewModel.isLoading = false;
        csod.engine.commit();
    });
};
var clearJobDetails = function () {
    csod.viewModel.jobDetails = {
        jobAd: "",
        title: "",
        externalDescription: "",
        ref: "",
        primaryLocation: {
            title: "",
            locationDisplayTitle: "",
            geocode: {
                latitude: "",
                longitude: ""
            },
            city: "",
            state: "",
            country: ""
        },
        additionalLocations: new Array(),
        applyNowStatusText: csod.locales.get("Apply Now", "Apply Now"),
        applyNowStatusId: -1,
        canUserApply: false,
        saveJobText: "",
        isSaveJobDisabled: true,
        postedDateLabel: "",
    };
    csod.viewModel.allLocations = new Array();
    csod.viewModel.locationDisplay = "";
    csod.engine.commit();
};
var setDefaultFilters = function (filters) {
    csod.viewModel.selectedFilters = [];
    filters.map(function (f, index) {
        if (f.defaultKey) {
            csod.viewModel.selectedFilters.push(f.defaultKey);
        }
    });
    var params = initStateFromQueryParams();
    var selectedCustomFilterKeys = params.selectedCustomCheckboxFilter;
    if (selectedCustomFilterKeys.length) {
        var customFilterSection = csod.viewModel.selectedFilters.find(function (f) { return f.filterType === models_1.FilterType.CustomFieldCheckbox; });
        if (customFilterSection === undefined) {
            csod.viewModel.selectedFilters.push({
                "filterType": models_1.FilterType.CustomFieldCheckbox,
                "keys": selectedCustomFilterKeys,
                "isOpen": true
            });
        }
    }
};
var transformFilters = function (filters) {
    var initParams = initStateFromQueryParams();
    if (!filters.length && !csod.viewModel.lastSelectedFilter && !initParams.searchQuery && !initParams.locationQuery) {
        csod.viewModel.filters = [];
        return false;
    }
    var selectedDropdowns = getSelectedCustomDropdownFilters();
    var initdropdown = initParams.selectedCustomDropDownFilters;
    if (csod.viewModel.IS_FIRST_LOAD && !selectedDropdowns.length) {
        selectedDropdowns = initdropdown;
    }
    if (csod.viewModel.IS_FIRST_LOAD) {
        transformFiltersFromQueryParams(initParams);
    }
    if (csod.viewModel.IS_FIRST_LOAD && selectedDropdowns.length) {
        var mainSearchDropdown = selectedDropdowns.find(function (d) { return d.id === csod.viewModel.cfMainSearchDropdownId; });
        if (mainSearchDropdown) {
            mainSearchDropdown.options.forEach(function (optionKey) {
                csod.viewModel.cfMainSearchDropDownOptions.find(function (o) { return o.value === optionKey; }).isChecked = true;
            });
        }
    }
    var selectedRadios = getSelectedCustomRadioFilters();
    var initRadioParams = initParams.selectedCustomRadioFilters;
    if (csod.viewModel.IS_FIRST_LOAD) {
        selectedRadios = initRadioParams;
    }
    if (!csod.viewModel.IS_FIRST_LOAD && csod.viewModel.filters.length) {
        var dropdownFilters = csod.viewModel.filters.filter(function (f) { return f.type === DROPDOWN_MULTI_SELECT; });
        dropdownFilters.forEach(function (fltr) {
            var incomingFilter = filters.find(function (f) { return f.dropdownId === fltr.id; });
            var defaultFilter = csod.viewModel.defaultFilters.find(function (f) { return f.id === fltr.id; });
            if (incomingFilter && defaultFilter) {
                incomingFilter['inputValue'] = fltr.inputValue || defaultFilter.inputValue;
            }
        });
    }
    csod.viewModel.filters = filters.map(function (f, index) {
        if (isCurrentFilterSameAsLastSelectedFilter(f)) {
            return csod.viewModel.lastSelectedFilter;
        }
        else {
            var filterValue = getFilter(f.filterType);
            var previouslySelectedValues_1 = filterValue.keys;
            var isOpen = filterValue.isOpen;
            if (f.filterType === models_1.FilterType.CustomFieldDropdown || f.filterType === models_1.FilterType.CustomFieldRadio) {
                filterValue = getCustomFilter(f);
                previouslySelectedValues_1 = filterValue.keys;
                isOpen = filterValue.isOpen;
            }
            var selectedValue_1 = "";
            var filter = {
                "selectedValue": "",
                "title": f.title,
                "isOpen": isOpen,
                "type": f.controlType,
                "maxHeight": "395px",
                "options": f.items.map(function (i, index) {
                    var option = {
                        "FilterCount": i.count,
                        "Id": i.key,
                        "LocalizedTitle": i.text,
                        "LocalizedTitleWithCount": i.text + " (" + i.count + ")",
                        "label": i.text + " (" + i.count + ")",
                        "value": i.key,
                        "isVisible": true
                    };
                    if (f.controlType === 'checkbox') {
                        if (previouslySelectedValues_1.indexOf(i.key) > -1) {
                            option["isChecked"] = true;
                        }
                    }
                    if (f.controlType === DROPDOWN_MULTI_SELECT) {
                        selectedDropdowns.forEach(function (element) {
                            if (element.id === f.dropdownId) {
                                element.options.forEach(function (opt) {
                                    if (opt === option.Id) {
                                        option["isChecked"] = true;
                                    }
                                });
                            }
                        });
                    }
                    if (f.controlType === DROPDOWN_SINGLE_SELECT) {
                        selectedDropdowns.forEach(function (element) {
                            if (element.id === f.dropdownId) {
                                element.options.forEach(function (opt) {
                                    if (opt === option.Id) {
                                        option["isChecked"] = true;
                                        selectedValue_1 = String(opt);
                                    }
                                    else {
                                        option["isChecked"] = false;
                                    }
                                });
                            }
                        });
                    }
                    if (f.filterType === models_1.FilterType.CustomFieldRadio) {
                        selectedRadios.forEach(function (r) {
                            if (r.id === f.dropdownId) {
                                f.items.forEach(function (opts) {
                                    selectedRadios.forEach(function (selRadio) {
                                        if (opts.key === selRadio.options[0]) {
                                            f.defaultKey = opts.key;
                                        }
                                    });
                                });
                            }
                        });
                    }
                    return option;
                }),
                "order": index,
                "filterName": f.filterType,
                "inputValue": f.inputValue || ''
            };
            if (f.dropdownId) {
                filter['id'] = f.dropdownId;
            }
            if (f.filterType === models_1.FilterType.CustomFieldCheckbox) {
                filter.maxHeight = "330px";
            }
            if (f.controlType === 'radio') {
                filter["selectedValue"] = previouslySelectedValues_1.length
                    ? previouslySelectedValues_1[0]
                    : f.defaultKey;
            }
            else if (selectedValue_1) {
                filter.selectedValue = selectedValue_1;
            }
            return filter;
        }
    });
};
var isCurrentFilterSameAsLastSelectedFilter = function (currentFilter) {
    var lastSelectedFilter = csod.viewModel.lastSelectedFilter;
    if (!lastSelectedFilter || currentFilter.filterType != lastSelectedFilter.filterName ||
        currentFilter.title != lastSelectedFilter.title) {
        return false;
    }
    else if (currentFilter.controlType === 'checkbox') {
        var selectedKeys_1 = lastSelectedFilter.options.filter(function (ob) { return ob.isChecked; }).flatMap(function (ob) { return ob.Id; });
        return currentFilter.items.filter(function (ob) { return selectedKeys_1.includes(ob.key); }).length == selectedKeys_1.length;
    }
    else if (currentFilter.controlType === 'radio') {
        return currentFilter.items.some(function (ob) { return ob.key == lastSelectedFilter.selectedValue; });
    }
    return false;
};
var transformFiltersFromQueryParams = function (initParams) {
    var searchQuery = initParams.searchQuery, locationQuery = initParams.locationQuery, placeId = initParams.placeId, country = initParams.country, state = initParams.state, city = initParams.city, date = initParams.date, distance = initParams.distance;
    if (searchQuery) {
        csod.viewModel.searchBanner.currentKeywordQuery = searchQuery;
    }
    if (locationQuery) {
        csod.viewModel.searchBanner.currentLocationQuery = locationQuery;
    }
    if (placeId) {
        csod.viewModel.searchBanner.placeId = placeId;
    }
    setSearchBannerInputValues(csod.viewModel.searchBanner.currentKeywordQuery, csod.viewModel.searchBanner.currentLocationQuery);
    setDefaultFiltersFromQueryString(country, models_1.FilterType.Country);
    setDefaultFiltersFromQueryString(state, models_1.FilterType.State);
    setDefaultFiltersFromQueryString(city, models_1.FilterType.City);
    setDefaultFiltersFromQueryString(date, models_1.FilterType.DatePosted);
    setDefaultFiltersFromQueryString(distance, models_1.FilterType.Distance);
};
var setSearchBannerInputValues = function (searchQuery, locationQuery) {
    var keywordInputDsk = document.getElementById('keywordSearchDsk');
    var keywordInputMob = document.getElementById('keywordSearchMob');
    var locationInputDsk = document.getElementById('locationSearchDsk');
    var locationInputMob = document.getElementById('locationSearchMob');
    var keywordInput = (keywordInputDsk || keywordInputMob);
    var locationInput = (locationInputDsk || locationInputMob);
    if (!keywordInput || !locationInput)
        return false;
    if (searchQuery !== null && searchQuery !== keywordInput.value) {
        keywordInput.value = searchQuery;
    }
    if (locationQuery !== null && locationQuery !== locationInput.value) {
        locationInput.value = locationQuery;
    }
};
var setDefaultFiltersFromQueryString = function (queryFilter, filterType) {
    if (queryFilter) {
        csod.viewModel.selectedFilters.push({
            filterType: filterType,
            isOpen: true,
            keys: queryFilter
        });
    }
};
var updateDropdownCustomFields = function (msddOPtionsCopy) {
    var filterSection = csod.viewModel.filters.find(function (f) { return f.id === csod.viewModel.cfMainSearchDropdownId; });
    if (filterSection) {
        var defaultFilterSection_1 = csod.viewModel.defaultFilters.find(function (fltr) { return fltr.id === filterSection.id; });
        msddOPtionsCopy.forEach(function (selectedOption) {
            var filterOption = filterSection.options.find(function (o) { return o.Id === selectedOption.value; });
            var defaultFilterOption = defaultFilterSection_1.options.find(function (o) { return o.Id === selectedOption.value; });
            var mainDDOption = csod.viewModel.cfMainSearchDropDownOptions.find(function (o) { return o.value === selectedOption.value; });
            if (filterOption) {
                filterOption.isChecked = selectedOption.isChecked;
            }
            if (defaultFilterOption) {
                defaultFilterOption.isChecked = selectedOption.isChecked;
            }
            if (mainDDOption && mainDDOption.isChecked !== undefined) {
                mainDDOption.isChecked = selectedOption.isChecked;
            }
        });
        var keys_1 = [];
        msddOPtionsCopy.forEach(function (o) {
            o.isChecked && keys_1.push(o.value);
        });
        csod.viewModel.selectedFilters.push({
            "filterType": defaultFilterSection_1.filterName,
            "keys": keys_1,
            "isOpen": defaultFilterSection_1.isOpen,
            "title": defaultFilterSection_1.title,
            "id": defaultFilterSection_1.id
        });
    }
};
var updateDropdownCustomFieldsMobile = function () {
    var filterSection = csod.viewModel.filters.find(function (f) { return f.id === csod.viewModel.cfMainSearchDropdownId; });
    if (filterSection) {
        filterSection.options.forEach(function (option) {
            var filterOption = csod.viewModel.cfMainSearchDropDownOptions.find(function (o) { return o.value === option.Id; });
            if (filterOption) {
                filterOption.isChecked = option.isChecked;
            }
        });
    }
    setSelectedFilters();
    updateQueryParams();
};
var transformCustomFieldFilters = function () { return new Promise(function (resolve, reject) {
    var customFields = csod.viewModel.customFieldIds;
    csod.viewModel.CustomFields = new Map();
    if (!customFields || !customFields.length) {
        resolve();
        return;
    }
    mapping_1.getCustomFields(customFields).then(function (fields) {
        fields.forEach(function (f) {
            var cf = {
                fieldId: f.id,
                allowMultiSelect: false,
                includeInMainSearch: false,
                title: f.name,
                count: 1,
                displayType: f.displayType,
                options: []
            };
            if (f.displayType === models_1.CustomFieldItemType.Dropdown || f.displayType === models_1.CustomFieldItemType.Radiobutton) {
                cf.options = f.items.filter(function (x) { return x.selectable; }).sort(function (a, b) { return (a.sortOrder) - (b.sortOrder); }).slice();
            }
            csod.viewModel.CustomFields.set(f.id, cf);
        });
        if (csod.viewModel.CustomFieldsObjects) {
            csod.viewModel.CustomFieldsObjects.forEach(function (f) {
                if (csod.viewModel.CustomFields.get(f.fieldId)) {
                    csod.viewModel.CustomFields.get(f.fieldId).allowMultiSelect = f.allowMultiSelect;
                    csod.viewModel.CustomFields.get(f.fieldId).includeInMainSearch = f.includeInMainSearch;
                }
            });
        }
        resolve();
    }).catch(function (e) {
        csod.logger.error("Failed to get the custom fields: " + e);
        reject();
    });
}); };
var AddCustomFieldCheckboxFilters = function (customFieldData) {
    var checkboxes = {
        title: csod.locales.get("Additional Filters", "Additional Filters"),
        controlType: searchFilterMapper.getControlType(models_1.FilterType.CustomFieldCheckbox),
        defaultKey: "",
        filterType: models_1.FilterType.CustomFieldCheckbox,
        doLocalize: true,
        items: [],
    };
    csod.viewModel.CustomFields.forEach(function (element) {
        if (element.displayType === models_1.CustomFieldItemType.Checkbox) {
            var customFieldCheckbox = customFieldData.find(function (f) { return +f.id === +element.fieldId; });
            if (customFieldCheckbox) {
                var selectedResponse = customFieldCheckbox.items.find(function (i) { return i.key === "yes"; });
                if (selectedResponse) {
                    if (selectedResponse.count > 0) {
                        checkboxes.items.push({
                            key: element.fieldId,
                            text: element.title,
                            count: selectedResponse.count
                        });
                    }
                }
                else if (csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled) {
                    checkboxes.items.push({
                        key: element.fieldId,
                        text: element.title,
                        count: 0
                    });
                }
            }
        }
    });
    if (csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled) {
        sortByCountDescAndTextAsc(checkboxes.items);
    }
    return checkboxes;
};
var AddCustomFieldDropdownFilters = function (customField, isMultiSelect, customFieldData) {
    var customFieldDropDown = customFieldData.find(function (f) { return +f.id === +customField.fieldId; });
    var controlType = searchFilterMapper.getControlType(models_1.FilterType.CustomFieldDropdown, isMultiSelect);
    var isCustomFieldInMainDropdown = +customField.fieldId === csod.viewModel.cfMainSearchDropdownId;
    var dropdown = {
        title: customField.title,
        controlType: controlType,
        defaultKey: "",
        filterType: models_1.FilterType.CustomFieldDropdown,
        dropdownId: customField.fieldId,
        doLocalize: true,
        items: [],
        inputValue: ''
    };
    if (csod.viewModel.cfLastSearchedFilterSnapshot && +customField.fieldId === +csod.viewModel.cfLastSearchedFilterSnapshot.id) {
        return GetLastSearchedCustomFieldFilterState(controlType, models_1.FilterType.CustomFieldDropdown, "");
    }
    else if (customFieldDropDown || csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled) {
        if (csod.viewModel.defaultFilters) {
            var defaultFilter = csod.viewModel.defaultFilters.find(function (f) { return f.id === customField.fieldId; });
            if (defaultFilter && defaultFilter.options.length !== customField.options.length) {
                csod.viewModel.cfFilterToResetOptions.push(customField.fieldId);
            }
        }
        customField.options.forEach(function (item) {
            var dropdownItem = customFieldDropDown && customFieldDropDown.items && customFieldDropDown.items.find(function (i) { return +i.key === +item.id; });
            if (dropdownItem) {
                dropdown.items.push({
                    key: item.id,
                    text: item.title,
                    count: dropdownItem.count
                });
            }
            else if (csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled) {
                dropdown.items.push({
                    key: item.id,
                    text: item.title,
                    count: 0
                });
            }
        });
        if (csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled) {
            sortByCountDescAndTextAsc(dropdown.items);
        }
        if (!isMultiSelect && dropdown.items.length > 0) {
            dropdown.items.splice(0, 0, {
                key: 0,
                text: "",
                count: csod.viewModel.cfDefaultDropdownText
            });
        }
        return dropdown;
    }
    return null;
};
var AddCusomFildDropdownToMainSearch = function (customField) {
    csod.viewModel.cfMainSearchDropdownTitle = customField.title;
    csod.viewModel.cfMainSearchDropDownOptions = [];
    customField.options.forEach(function (option) {
        var opt = {
            label: option.title,
            value: option.id,
            isChecked: false
        };
        csod.viewModel.cfMainSearchDropDownOptions.push(opt);
    });
};
var GetLastSearchedCustomFieldFilterState = function (controlType, fieldType, defaultKey) {
    var customField = csod.viewModel.cfLastSearchedFilterSnapshot;
    var field = {
        title: customField.title,
        controlType: controlType,
        defaultKey: defaultKey,
        filterType: fieldType,
        dropdownId: customField.id,
        doLocalize: true,
        items: [],
        inputValue: ''
    };
    customField.options.forEach(function (item) {
        field.items.push({
            key: item.Id,
            text: item.LocalizedTitle,
            count: item.FilterCount
        });
    });
    return field;
};
var AddCustomFieldRadioFilter = function (customField, customFieldData) {
    var defaultKey = "";
    csod.viewModel.selectedFilters.forEach(function (element) {
        if (customField.title === element.title) {
            defaultKey = element.keys[0];
        }
    });
    var customFieldRadio = customFieldData.find(function (f) { return +f.id === +customField.fieldId; });
    var controlType = searchFilterMapper.getControlType(models_1.FilterType.CustomFieldRadio);
    if (csod.viewModel.cfLastSearchedFilterSnapshot && +customField.fieldId === +csod.viewModel.cfLastSearchedFilterSnapshot.id) {
        return GetLastSearchedCustomFieldFilterState(controlType, models_1.FilterType.CustomFieldRadio, defaultKey);
    }
    else if (customFieldRadio || csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled) {
        var radio_1 = {
            title: customField.title,
            controlType: controlType,
            defaultKey: defaultKey,
            filterType: models_1.FilterType.CustomFieldRadio,
            dropdownId: customField.fieldId,
            doLocalize: true,
            items: []
        };
        customField.options.forEach(function (item) {
            var radioItem = customFieldRadio && customFieldRadio.items && customFieldRadio.items.find(function (i) { return +i.key === +item.id; });
            if (radioItem) {
                radio_1.items.push({
                    key: item.id,
                    text: item.title,
                    count: radioItem.count
                });
            }
            else if (csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled) {
                radio_1.items.push({
                    key: item.id,
                    text: item.title,
                    count: 0
                });
            }
        });
        if (csod.viewModel.isEnableAllValuesForCustomFieldInMFCEnabled) {
            sortByCountDescAndTextAsc(radio_1.items);
        }
        if (radio_1.items.length > 0) {
            radio_1.items.push({
                key: 0,
                text: "",
                count: csod.viewModel.cfDefaultRadioButtonText
            });
        }
        return radio_1;
    }
    else {
        return null;
    }
};
var resetLastSelectedFilters = function () {
    csod.viewModel.lastSelectedFilter = null;
    csod.viewModel.cfLastSearchedFilterSnapshot = null;
};
var updteSelectedFilter = function (selectedFilter, flag) {
    selectedFilter.keys = selectedFilter.keys.filter(function (key) { return key !== flag.id; });
    updateFilterFlags();
    runNewSearch();
};
var setSelectedFilters = function () {
    csod.viewModel.selectedFilters = [];
    csod.viewModel.filters.map(function (f, index) {
        var keys = [];
        if (f.type === 'radio') {
            keys.push(f.selectedValue);
        }
        else if (f.type === 'checkbox') {
            f.options.forEach(function (o) {
                o.isChecked && keys.push(o.value);
            });
        }
        else if (f.type === DROPDOWN_MULTI_SELECT) {
            var filter = csod.viewModel.defaultFilters.find(function (fltr) { return fltr.id === f.id; });
            var ddKeys_1 = new Set();
            filter.options.forEach(function (opt) {
                opt.isChecked && ddKeys_1.add(opt.value);
            });
            f.options.forEach(function (o) {
                o.isChecked && ddKeys_1.add(o.value);
            });
            ddKeys_1.forEach(function (element) {
                keys.push(element);
            });
        }
        else if (f.type === DROPDOWN_SINGLE_SELECT) {
            f.options.forEach(function (o) {
                o.isChecked && keys.push(o.value);
            });
        }
        csod.viewModel.selectedFilters.push({
            "filterType": f.filterName,
            "keys": keys,
            "isOpen": f.isOpen,
            "title": f.title,
            "id": f.id
        });
    });
    if (csod.viewModel.cfMainSearchDropdownId !== -1) {
        var keys_2 = [];
        var mainsearchDropdown_1 = csod.viewModel.CustomFields.get(csod.viewModel.cfMainSearchDropdownId);
        var filter_1 = csod.viewModel.filters.find(function (fltr) { return fltr.id === mainsearchDropdown_1.fieldId; });
        if (filter_1) {
            csod.viewModel.cfMainSearchDropDownOptions.forEach(function (o) {
                if (filter_1.options.find(function (f) { return f.Id === o.value; })) {
                    o.isChecked && keys_2.push(o.value);
                }
            });
            var selectedFilter_1 = csod.viewModel.selectedFilters.find(function (f) { return f.id === mainsearchDropdown_1.fieldId; });
            if (selectedFilter_1) {
                keys_2.forEach(function (key) {
                    var k = selectedFilter_1.keys.find(function (i) { return i === key; });
                    if (k === undefined) {
                        selectedFilter_1.keys.push(key);
                    }
                });
            }
            else {
                csod.viewModel.selectedFilters.push({
                    "filterType": models_1.FilterType.CustomFieldDropdown,
                    "keys": keys_2,
                    "isOpen": true,
                    "title": mainsearchDropdown_1.title,
                    "id": mainsearchDropdown_1.fieldId
                });
            }
        }
    }
    updateMainSearchDropdownOptions();
    updateFilterFlags();
};
var updateFilterFlags = function () {
    csod.viewModel.selectedFilterFlaglist = [];
    csod.viewModel.selectedFilters.forEach(function (selectedFilter) {
        if (selectedFilter.keys.length && selectedFilter.keys[0] !== "") {
            var filterSection_1 = csod.viewModel.filters.find(function (fltr) { return fltr.id === selectedFilter.id && fltr.filterName === selectedFilter.filterType; });
            selectedFilter.keys.forEach(function (key) {
                var option = filterSection_1.options.find(function (opt) { return opt.Id === key; });
                if (filterSection_1.filterName === models_1.FilterType.CustomFieldDropdown) {
                    var defaultFilter = csod.viewModel.defaultFilters.find(function (fltr) { return fltr.id === selectedFilter.id && fltr.filterName === selectedFilter.filterType; });
                    if (defaultFilter) {
                        option = defaultFilter.options.find(function (opt) { return opt.Id === key; });
                    }
                }
                if (option && option.Id !== searchFilterMapper.getDefaultKey(filterSection_1.filterName)) {
                    csod.viewModel.selectedFilterFlaglist.push({
                        id: option.Id,
                        name: option.LocalizedTitle,
                        type: selectedFilter.filterType,
                        filterId: selectedFilter.id,
                    });
                }
            });
        }
    });
};
var updateMainSearchDropdownOptions = function () {
    var defaultFilters = csod.viewModel.defaultFilters.find(function (fltr) { return fltr.id === csod.viewModel.cfMainSearchDropdownId; });
    if (defaultFilters) {
        csod.viewModel.cfMainSearchDropDownOptions.forEach(function (option) {
            option.isChecked = false;
        });
        defaultFilters.options.forEach(function (option) {
            if (option.Id !== 0 && option.isChecked !== undefined) {
                csod.viewModel.cfMainSearchDropDownOptions.find(function (o) { return o.value === option.Id; }).isChecked = option.isChecked;
            }
        });
    }
};
var updateQueryParams = function () {
    var prevParams = exports.getQueryParams();
    var params = {
        c: csod.context.corp,
        cfcb: getSelectedCustomCheckboxFilters().join(',') || undefined,
    };
    var initParams = initStateFromQueryParams();
    var initdropdownParams = initParams.selectedCustomDropDownFilters;
    var selectedDropdown = getSelectedCustomDropdownFilters();
    var selectedRadios = getSelectedCustomRadioFilters();
    var initRadioParams = initParams.selectedCustomRadioFilters;
    if (csod.viewModel.IS_FIRST_LOAD && !selectedDropdown.length && initdropdownParams.length) {
        selectedDropdown = initdropdownParams;
    }
    params["cfdd"] = selectedDropdown.length ? selectedDropdown : undefined;
    if (csod.viewModel.IS_FIRST_LOAD) {
        selectedRadios = initRadioParams;
    }
    params["cfrb"] = selectedRadios.length ? selectedRadios : undefined;
    if (csod.viewModel.searchBanner.currentKeywordQuery) {
        params["sq"] = encodeURIComponent(csod.viewModel.searchBanner.currentKeywordQuery);
    }
    if (csod.viewModel.searchBanner.currentLocationQuery) {
        params["lq"] = encodeURIComponent(csod.viewModel.searchBanner.currentLocationQuery);
    }
    if (csod.viewModel.searchBanner.placeId) {
        params["pl"] = encodeURIComponent(csod.viewModel.searchBanner.placeId);
    }
    params['country'] = updateFilterQueryParams(models_1.FilterType.Country);
    params['state'] = updateFilterQueryParams(models_1.FilterType.State);
    params['city'] = updateFilterQueryParams(models_1.FilterType.City);
    params['date'] = updateFilterQueryParams(models_1.FilterType.DatePosted);
    params['distance'] = updateFilterQueryParams(models_1.FilterType.Distance);
    for (var par in prevParams) {
        if (prevParams.hasOwnProperty(par)) {
            if (!params.hasOwnProperty(par)) {
                params[par] = prevParams[par];
            }
        }
    }
    history_1.default.replace({
        pathname: window.location.pathname,
        search: "?" + qs.stringify(params, { encode: false }),
        hash: window.location.hash
    });
    csod.viewModel.searchUrl = careerSiteUrlProvider.getSearchURL();
};
var updateFilterQueryParams = function (filterType) {
    var filter = csod.viewModel.selectedFilters.find(function (x) { return x.filterType == filterType; });
    if (filter &&
        filter.keys.length &&
        !(filterType === models_1.FilterType.Distance && filter.keys[0] === '100 mi') &&
        !(filterType === models_1.FilterType.DatePosted && filter.keys[0] === 'Anytime')) {
        return encodeURIComponent(filter.keys.join('_'));
    }
};
var getNonCustomFieldParams = function () {
    var prevParams = exports.getQueryParams();
    var params = {
        c: csod.context.corp,
    };
    var paramsToRemove = [
        'cfdd',
        'cfrb',
        'cfcb',
        'sq',
        'lq',
        'pl',
        'country',
        'state',
        'city',
        'date',
        'distance',
    ];
    for (var par in prevParams) {
        if (prevParams.hasOwnProperty(par)) {
            if (!params.hasOwnProperty(par) &&
                paramsToRemove.indexOf(par) === -1) {
                params[par] = prevParams[par];
            }
        }
    }
    return "?" + qs.stringify(params, { encode: false });
};
var resetQueryParams = function () {
    history_1.default.replace({
        pathname: window.location.pathname,
        search: getNonCustomFieldParams(),
        hash: window.location.hash
    });
    csod.viewModel.searchUrl = careerSiteUrlProvider.getSearchURL();
};
exports.getQueryParams = function () {
    return qs.parse(location.search.replace(/^\?/, ''), { encode: false });
};
var initStateFromQueryParams = function () {
    var params = exports.getQueryParams();
    var filters = params.cfcb ? params.cfcb.split(',') : [];
    var dropdowns = params.cfdd ? params.cfdd : [];
    var radios = params.cfrb ? params.cfrb : [];
    var parsedParams = {
        selectedCustomCheckboxFilter: filters.map(function (f) { return parseInt(f, 10); }),
        selectedCustomDropDownFilters: decodeRadioParams(dropdowns),
        selectedCustomRadioFilters: decodeRadioParams(radios),
        searchQuery: params.sq || '',
        locationQuery: params.lq || '',
        placeId: params.pl || '',
        country: params.country ? params.country.split('_') : [],
        state: params.state ? params.state.split('_') : [],
        city: params.city ? params.city.split('_') : [],
        date: params.date ? [params.date] : null,
        distance: params.distance ? [params.distance] : null,
        hideCustomHeaderAndFooter: params.hhf ? params.hhf : false,
        alert: params.alert && params.alert == '1'
    };
    if (csod.viewModel.IS_FIRST_LOAD) {
        parsedParams.selectedCustomCheckboxFilter = reconcileCFQueryParamsIds(parsedParams.selectedCustomCheckboxFilter);
        parsedParams.selectedCustomDropDownFilters = reconcileCFQueryParamsOptions(parsedParams.selectedCustomDropDownFilters);
        parsedParams.selectedCustomRadioFilters = reconcileCFQueryParamsOptions(parsedParams.selectedCustomRadioFilters);
    }
    return parsedParams;
};
var decodeRadioParams = function (radios) {
    return radios.map(function (r) {
        return {
            id: parseInt(r.id, 10),
            options: r.options.map(function (o) { return parseInt(o, 10); })
        };
    });
};
var reconcileCFQueryParamsIds = function (filters) {
    var rcf = [];
    filters.forEach(function (f) {
        if (csod.viewModel.CustomFields.has(f)) {
            rcf.push(f);
        }
    });
    return rcf;
};
var reconcileCFQueryParamsOptions = function (filters) {
    var rcf = [];
    filters.forEach(function (f) {
        if (csod.viewModel.CustomFields.has(f.id)) {
            var cf = csod.viewModel.CustomFields.get(f.id);
            var m_1 = new Map();
            cf.options.forEach(function (o) {
                m_1.set(o.id, o);
            });
            var rOptions_1 = [];
            f.options.forEach(function (oid) {
                if (m_1.has(oid)) {
                    rOptions_1.push(oid);
                }
            });
            if (rOptions_1.length) {
                rcf.push({ id: f.id, options: rOptions_1 });
            }
        }
    });
    return rcf;
};
var sortByCountDescAndTextAsc = function (items) {
    items.sort(function (a, b) {
        if (b.count !== a.count) {
            return b.count - a.count;
        }
        return a.text
            .toLocaleLowerCase()
            .localeCompare(b.text.toLocaleLowerCase());
    });
};
var filters = [
    {
        "title": "Date Posted",
        "controlType": "radio",
        "filterType": "DatePosted",
        "items": [
            {
                "key": "1day",
                "text": "Within 1 Day",
                "count": 2
            },
            {
                "key": "3days",
                "text": "Within 3 Days",
                "count": 3
            },
            {
                "key": "7days",
                "text": "Within 7 Days",
                "count": 5
            },
            {
                "key": "15days",
                "text": "Within 15 Days",
                "count": 8
            },
            {
                "key": "30days",
                "text": "Within 30 Days",
                "count": 9
            },
            {
                "key": "anytime",
                "text": "Anytime",
                "count": 15
            }
        ],
        "defaultKey": "anytime"
    },
    {
        "title": "Distance",
        "controlType": "radio",
        "filterType": "distance",
        "items": [
            {
                "key": "5Mi_8Km",
                "text": "5 mi / 8 km",
                "count": 0
            },
            {
                "key": "10Mi_16Km",
                "text": "10 mi / 16 km",
                "count": 0
            },
            {
                "key": "15Mi_24Km",
                "text": "15 mi / 24 km",
                "count": 0
            },
            {
                "key": "25Mi_40Km",
                "text": "25 mi / 40 km (Default)",
                "count": 0
            },
            {
                "key": "50Mi_80Km",
                "text": "50 mi / 80 km",
                "count": 0
            },
            {
                "key": "100Mi_160Km",
                "text": "100 mi / 160 km",
                "count": 0
            }
        ],
        "defaultKey": "25Mi_40Km"
    },
    {
        "title": "Country",
        "controlType": "checkbox",
        "filterType": "country",
        "items": [
            {
                "key": "usa",
                "text": "United States",
                "count": 1
            },
            {
                "key": "everywhere",
                "text": "Everywhere Else",
                "count": 999
            }
        ],
        "defaultKey": ""
    },
    {
        "title": "State/Province",
        "controlType": "checkbox",
        "filterType": "state",
        "items": [
            {
                "key": "california",
                "text": "California",
                "count": 1
            },
            {
                "key": "other",
                "text": "Other States",
                "count": 0
            }
        ],
        "defaultKey": ""
    },
    {
        "title": "City",
        "controlType": "checkbox",
        "filterType": "city",
        "items": [
            {
                "key": "losangeles",
                "text": "Los Angeles",
                "count": 1
            },
            {
                "key": "bifrost",
                "text": "Bifrost Bridge",
                "count": 1
            }
        ],
        "defaultKey": ""
    }
];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/pages/home/page.ts
// module id = 992
// module chunks = 0